import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { EuiSpacer } from '@elastic/eui';
import APIv2Box from 'components/Frequently_Asked_Question/WQHD_MQTTv5_Alarmserver_APIv2_NodeRED/PrimaryBox';
import PrimaryBoxInfo from 'components/Advanced_User/All_Home_Assistant_Tutorials/PrimaryBox.jsx';
import PrimaryBox from 'components/Software/Linux/Home_Assistant/PrimaryBox3';
import NavButtons from 'components/Software/Linux/NavButtons';
import ForumBox from 'components/Software/Linux/Home_Assistant/ForumBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Home Assistant with Docker",
  "path": "/Software/Linux/Home_Assistant/",
  "dateChanged": "2024-04-02",
  "author": "Mike Polinowski",
  "excerpt": "Home Assistant is a open source home automation that puts local control and privacy first. Powered by a worldwide community of tinkerers and DIY enthusiasts. Perfect to run on a Raspberry Pi or a local server. Compatible with the camera models IN-8401 2K+ WQHD, IN-8425 2K+ WQHD, IN-9408 2K+ WQHD, IN-9420 2K+ WQHD",
  "image": "./AU_SearchThumb_HomeAssistant.png",
  "social": "/images/Search/AU_SearchThumb_HomeAssistant.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_Advanced_HomeAssistant_white.webp",
  "chapter": "Software",
  "category": "smarthome",
  "type": "Home Assistant"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">






    <SEOHelmet title='Home Assistant with Docker' dateChanged='2024-04-02' author='Mike Polinowski' tag='INSTAR IP Camera' description='Home Assistant is a open source home automation that puts local control and privacy first. Powered by a worldwide community of tinkerers and DIY enthusiasts. Perfect to run on a Raspberry Pi or a local server. Compatible with the camera models IN-8401 2K+ WQHD, IN-8425 2K+ WQHD, IN-9408 2K+ WQHD, IN-9420 2K+ WQHD' image='/images/Search/AU_SearchThumb_HomeAssistant.png' twitter='/images/Search/AU_SearchThumb_HomeAssistant.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationEN={props.location.pathname} locationDE='/de/Software/Linux/Home_Assistant/' locationFR='/fr/Software/Linux/Home_Assistant/' crumbLabel="Home Assistant" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <PrimaryBoxInfo mdxType="PrimaryBoxInfo" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h1 {...{
      "id": "home-assistant-linux",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#home-assistant-linux",
        "aria-label": "home assistant linux permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Home Assistant (LINUX)`}</h1>
    <PrimaryBox mdxType="PrimaryBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#home-assistant-linux"
        }}>{`Home Assistant (LINUX)`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#installation"
            }}>{`Installation`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#live-video"
            }}>{`Live Video`}</a>
            <ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "#rtsp-mjpeg-and-jpg-streaming"
                }}>{`RTSP, MJPEG and JPG Streaming`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "#webrtc"
                }}>{`WebRTC`}</a></li>
            </ul>
          </li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#adding-your-camera-live-stream-using-the-onvif-service"
            }}>{`Adding your Camera Live Stream using the ONVIF Service`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#control-your-camera-through-mqtt"
            }}>{`Control your Camera through MQTT`}</a>
            <ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "#connect-your-mqtt-broker"
                }}>{`Connect your MQTT Broker`}</a></li>
              <li parentName="ul"><a parentName="li" {...{
                  "href": "#add-mqtt-topics-to-the-home-assistant-ui"
                }}>{`Add MQTT Topics to the Home Assistant UI`}</a>
                <ul parentName="li">
                  <li parentName="ul"><a parentName="li" {...{
                      "href": "#declare-the-camera-mqtt-device"
                    }}>{`Declare the Camera MQTT Device`}</a></li>
                  <li parentName="ul"><a parentName="li" {...{
                      "href": "#mqtt-switches"
                    }}>{`MQTT Switches`}</a></li>
                  <li parentName="ul"><a parentName="li" {...{
                      "href": "#mqtt-buttons"
                    }}>{`MQTT Buttons`}</a></li>
                  <li parentName="ul"><a parentName="li" {...{
                      "href": "#mqtt-sliders"
                    }}>{`MQTT Sliders`}</a></li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "installation",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#installation",
        "aria-label": "installation permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Installation`}</h2>
    <p>{`Home Assistant now provides a Docker image that can be pulled from the Docker Hub:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`docker pull homeassistant/home-assistant:stable`}</code></pre></div>
    <p>{`To persist all data generated by Home Assistant we can create directories that can later be mounted into the running container. On a Linux host system you also need to set proper  read&write permissions, e.g.:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`sudo`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`mkdir`}</span>{` -p /opt/homeassistant/config
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`sudo`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`chmod`}</span>{` -R `}<span parentName="code" {...{
            "className": "token number"
          }}>{`775`}</span>{` /opt/homeassistant`}</code></pre></div>
    <p>{`The container can now be started as follows:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`docker run -d --rm --privileged --net`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{`host --name`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'home-assistant'`}</span>{` -e `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'TZ=Europe/Berlin'`}</span>{` -v /opt/homeassistant/config:/config homeassistant/home-assistant:stable`}</code></pre></div>
    <p>{`And the web frontend will come up on `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`http://localhost:8123`}</code>{`:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/b664e69f3fef14120e3724ee62fc0081/d3f96/Home_Assistant_01.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "36.95652173913043%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAIAAACHqfpvAAAACXBIWXMAAA7rAAAO6wFxzYGVAAAAgUlEQVQY053NSQ6DIACFYc4lUaS2TGFG0DBo73+KJl26sCnJv3xfHljcLtaq91OmhoXHxDyohTO/aVokJgYTA8ZUaX6T1Ca7IbVCxAbE7jGc+fCdAe2ycpnJSET4+XkJKF+UL1xvrw6sQ7WxSZef3P+NbTxMqFTGnmcbD+0LUz34A1F9cUu3oEDDAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/b664e69f3fef14120e3724ee62fc0081/e4706/Home_Assistant_01.avif 230w", "/en/static/b664e69f3fef14120e3724ee62fc0081/d1af7/Home_Assistant_01.avif 460w", "/en/static/b664e69f3fef14120e3724ee62fc0081/7f308/Home_Assistant_01.avif 920w", "/en/static/b664e69f3fef14120e3724ee62fc0081/2675f/Home_Assistant_01.avif 1093w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/b664e69f3fef14120e3724ee62fc0081/a0b58/Home_Assistant_01.webp 230w", "/en/static/b664e69f3fef14120e3724ee62fc0081/bc10c/Home_Assistant_01.webp 460w", "/en/static/b664e69f3fef14120e3724ee62fc0081/966d8/Home_Assistant_01.webp 920w", "/en/static/b664e69f3fef14120e3724ee62fc0081/fe0ce/Home_Assistant_01.webp 1093w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/b664e69f3fef14120e3724ee62fc0081/81c8e/Home_Assistant_01.png 230w", "/en/static/b664e69f3fef14120e3724ee62fc0081/08a84/Home_Assistant_01.png 460w", "/en/static/b664e69f3fef14120e3724ee62fc0081/c0255/Home_Assistant_01.png 920w", "/en/static/b664e69f3fef14120e3724ee62fc0081/d3f96/Home_Assistant_01.png 1093w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/b664e69f3fef14120e3724ee62fc0081/c0255/Home_Assistant_01.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h2 {...{
      "id": "live-video",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#live-video",
        "aria-label": "live video permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Live Video`}</h2>
    <h3 {...{
      "id": "rtsp-mjpeg-and-jpg-streaming",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#rtsp-mjpeg-and-jpg-streaming",
        "aria-label": "rtsp mjpeg and jpg streaming permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`RTSP, MJPEG and JPG Streaming`}</h3>
    <p>{`We recommend that you use the `}<a parentName="p" {...{
        "href": "#adding-your-camera-using-the-onvif-service"
      }}>{`ONVIF Service`}</a>{` described below to add your camera's live video. But you can also add the stream manually via the `}<a parentName="p" {...{
        "href": "/en/Frequently_Asked_Question/Home_Assistant_INSTAR_WQHD_Camera_Live_Video/"
      }}>{`Generic Camera Integration`}</a>{` using your cameras `}<a parentName="p" {...{
        "href": "/en/Outdoor_Cameras/IN-9420_WQHD/Video_Streaming/"
      }}>{`RTSP & MJPEG Stream or Snapshots`}</a>{`.`}</p>
    <h3 {...{
      "id": "webrtc",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#webrtc",
        "aria-label": "webrtc permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`WebRTC`}</h3>
    <p>{`It is usually considered to be more stable to use WebRTC for your camera video stream. Your camera does not yet provide a WebRTC service - but you can use `}<a parentName="p" {...{
        "href": "/en/Frequently_Asked_Question/WebRTC_Livevideo_Smarthome/"
      }}>{`go2RTC to re-stream your camera's RTSP stream`}</a>{`. This setup is a little bit more advanced and requires starting a Docker container and have it running parallel to your Home Assistant container.`}</p>
    <h2 {...{
      "id": "adding-your-camera-live-stream-using-the-onvif-service",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#adding-your-camera-live-stream-using-the-onvif-service",
        "aria-label": "adding your camera live stream using the onvif service permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Adding your Camera Live Stream using the ONVIF Service`}</h2>
    <p>{`Start by making sure that the `}<a parentName="p" {...{
        "href": "/en/Web_User_Interface/1440p_Series/Network/ONVIF/"
      }}>{`ONVIF service`}</a>{` is actually active inside your cameras webUI. We will need the `}<strong parentName="p">{`ONVIF WS-Security`}</strong>{` to enable HomeAssitant to connect - but I will leave it `}<strong parentName="p">{`deactivated here`}</strong>{` for the admin user and create a user with limited rights for the ONVIF sevrice in the next step:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "902px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/7217e5ea0225ba745668fbd69935b497/58213/Home_Assistant_02.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "46.95652173913043%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAIAAAC9o5sfAAAACXBIWXMAAA7rAAAO6wFxzYGVAAABjUlEQVQoz22PzUsbQRjGc8u9C5sqYWYhl8xmD4kYiWspNavZ3WR3spl3ZnbGLRatgpbSQCFgxCiIX9j/oZSeWttTwf+vJBsQP348h/fy43neQr1edxzHtom3cxEd/el8/dke/mh/eSGbw+/Z5X24PVowDYRwpVIp1Go127ar1Wp8eL19+U9OfonJbzG5e57353/3bu/X6MfXpoGxhRAq2Lad+x3vnRaJHEQKqOZ9BVRBrPns5jRlEQvXWbfdWlkul8sYIYzxXCaEBEGwlWVpqpTSSmmtt9JUCSnzAJdweJZ+OnXdNYwxQsiyrEdylmVCCD5DCA4Agwcg/DCOd49WXdeyppvnsx3HIYT4vi+lZE8AYMCB8z6lb1ebm+tvWq1W3jydTQjJf/Z9X2stZwBArjLaHfQ6LA69qOcGwQalzWbTMIxHct4shJiV5XBgCd8bqeENPzgZJ/yqz06YWGo0isXi4sKUh9me5yVJQimN59C41+3vjAafv8X7p+Mgvt4IjsNoqdF4ZRimaZZKpf9bFZqke7+UsAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/7217e5ea0225ba745668fbd69935b497/e4706/Home_Assistant_02.avif 230w", "/en/static/7217e5ea0225ba745668fbd69935b497/d1af7/Home_Assistant_02.avif 460w", "/en/static/7217e5ea0225ba745668fbd69935b497/4d463/Home_Assistant_02.avif 902w"],
              "sizes": "(max-width: 902px) 100vw, 902px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/7217e5ea0225ba745668fbd69935b497/a0b58/Home_Assistant_02.webp 230w", "/en/static/7217e5ea0225ba745668fbd69935b497/bc10c/Home_Assistant_02.webp 460w", "/en/static/7217e5ea0225ba745668fbd69935b497/5cb76/Home_Assistant_02.webp 902w"],
              "sizes": "(max-width: 902px) 100vw, 902px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/7217e5ea0225ba745668fbd69935b497/81c8e/Home_Assistant_02.png 230w", "/en/static/7217e5ea0225ba745668fbd69935b497/08a84/Home_Assistant_02.png 460w", "/en/static/7217e5ea0225ba745668fbd69935b497/58213/Home_Assistant_02.png 902w"],
              "sizes": "(max-width: 902px) 100vw, 902px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/7217e5ea0225ba745668fbd69935b497/58213/Home_Assistant_02.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`To create an ONVIF user open the `}<a parentName="p" {...{
        "href": "/en/Web_User_Interface/1440p_Series/System/User/"
      }}>{`User Management Menu`}</a>{` and click the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`+`}</code>{` icon to create a new user with the `}<strong parentName="p">{`Guest Preset`}</strong>{` and the __ONVIF (Admin) role:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "915px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/6d5b1a78befc40ecc2ef52fd63448d87/4255a/Home_Assistant_03.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "36.95652173913043%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAIAAACHqfpvAAAACXBIWXMAAA7rAAAO6wFxzYGVAAABSElEQVQY012OW0vCcBjG9xWCYB2k/cPV1g7eLMlU1EEaxE65zXmY7n9sGuVNl32FBLv2C4Xe19cJtyTqx4/34oWH5+FKeklVNVk6v2qHjejl+v654j2VnUfDnv2zbE9v4atp9Q8PeFEUATjldF3X9NJZEXjzZbr6HCw+4uUmXm56i3Xv7Y+T9/Vs9dUI5vz+XrEoAiBwSsaFLLeaTc91XMdyHTu7lufYv7q2c2e5xC63Lo/4o5MMTs2QJKnTviEYjePRcNDHCCXJJI5HECbDQT+ZjMfxCEOIHpJKvVI4LggZnKZpP+FOZzqdUUoRQmmaUkoJIZRSCGH+pJQyymq1OgBAEIRts5aRh9M0xRhDCBljCCGMMSEkSRJCCEKIEMIYq1ar+eZts6qqiqLIsmyaZhRF/o5ut+v7frgjCALfD8IwNAyD5/l89jdDEXzRVpBDNAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/6d5b1a78befc40ecc2ef52fd63448d87/e4706/Home_Assistant_03.avif 230w", "/en/static/6d5b1a78befc40ecc2ef52fd63448d87/d1af7/Home_Assistant_03.avif 460w", "/en/static/6d5b1a78befc40ecc2ef52fd63448d87/6e770/Home_Assistant_03.avif 915w"],
              "sizes": "(max-width: 915px) 100vw, 915px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/6d5b1a78befc40ecc2ef52fd63448d87/a0b58/Home_Assistant_03.webp 230w", "/en/static/6d5b1a78befc40ecc2ef52fd63448d87/bc10c/Home_Assistant_03.webp 460w", "/en/static/6d5b1a78befc40ecc2ef52fd63448d87/632b0/Home_Assistant_03.webp 915w"],
              "sizes": "(max-width: 915px) 100vw, 915px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/6d5b1a78befc40ecc2ef52fd63448d87/81c8e/Home_Assistant_03.png 230w", "/en/static/6d5b1a78befc40ecc2ef52fd63448d87/08a84/Home_Assistant_03.png 460w", "/en/static/6d5b1a78befc40ecc2ef52fd63448d87/4255a/Home_Assistant_03.png 915w"],
              "sizes": "(max-width: 915px) 100vw, 915px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/6d5b1a78befc40ecc2ef52fd63448d87/4255a/Home_Assistant_03.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "897px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/c992d0bdeed623fbf0608605967c5709/3a737/Home_Assistant_04.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "97.82608695652175%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAACXBIWXMAAA7rAAAO6wFxzYGVAAADK0lEQVQ4y3WSzW8bRRjGfY+UU0ipHXt3nQ/b3ew6TmNq75hQiL1sxrs7O98zu+u0Em0ikBDihJSIiFNPTYED3KjEAYkTfwJHVAtx5t9Bu7ZbQcOjV6M5zKPf+77PVBzH7bR2+h8h/+mz4/z6OL8G+mqoLh/If9VAXY70Jfvy++GHp+/eeccwzO3t7cq+4+42Gyfqi89e/q2e/5F+O8+/m8ubV/z5K3kzly/m8mYububqxfyTH/968sOfDoB372yYlmWaZsW27VarNRwMKEZJPF0UQSGankJ/fOqP4ar88UkIA9u+V61WDcOo1+tLs+d5aZoyxshKIYqCKPBDfwInixrDcYTCbrdbr9cbpSr7+/vtdtvzgNZaKSmEIIRgjMM4hDGEMZycThY1DsZhHPZ6PcuyGo2GYRiF+TVZKSU4X5CDj4OHHzw8Hr0/AoVGYOQNvSAIut1uo9FYwJdkAAoyYwxjXJAJOZlMPDB6MBgOBsNhcQ76/b7v+47jVKvVJdm27b29Pc/zlFKcc1o6OcE8nCLok+kknPp+5MMI4gRTSk3TXFtbMwyjVqu9WZjWSkrJCzhhFAtKBCOKE8EJ4ZQJrrXmnFuWtb6+vrGxsbm5+abts0ePX3cupOJCCCEp45gpIRWjDCGEMbZtu1arbW1tFVGV5pYHgM4fF50LXpj1TKeZUopSqpTOskxKuVik4zimaTZLVRzHKaPy8jzX5cIJIakulOpUCKGULO6pXqToOI5hGFap5cygNCtdvFhGXYSNyVv6r7kgA6Czs2JmzgnGYiXGGF+JUno72fOA0sWQZWAsiiIIYRAEvu8jhISQnPPF572FDACYzfIsS7MsZYwihMIwhIWmCCWk/LGUEPp/M3OZIioxV4RQKWXZhNSCMRwnGEWURpQm9NaZPXAxI5+fxZ/miFGCMcFJgikn2TmeXQgxexrHFyjJE2y/TR564OVX6Pdn09++hpmkhHFGEpY9Sa9+lt/8en5+/VMAfwnJVZS0Xdc0jKbVLMydTqfdbruue78/OLj/Xvew3+sdrtQ7PHB7XefgwHWPjtyjo16/3+7ca+7sNnf2mju7/wCRZkL1sjgNwQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/c992d0bdeed623fbf0608605967c5709/e4706/Home_Assistant_04.avif 230w", "/en/static/c992d0bdeed623fbf0608605967c5709/d1af7/Home_Assistant_04.avif 460w", "/en/static/c992d0bdeed623fbf0608605967c5709/c400a/Home_Assistant_04.avif 897w"],
              "sizes": "(max-width: 897px) 100vw, 897px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/c992d0bdeed623fbf0608605967c5709/a0b58/Home_Assistant_04.webp 230w", "/en/static/c992d0bdeed623fbf0608605967c5709/bc10c/Home_Assistant_04.webp 460w", "/en/static/c992d0bdeed623fbf0608605967c5709/10735/Home_Assistant_04.webp 897w"],
              "sizes": "(max-width: 897px) 100vw, 897px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/c992d0bdeed623fbf0608605967c5709/81c8e/Home_Assistant_04.png 230w", "/en/static/c992d0bdeed623fbf0608605967c5709/08a84/Home_Assistant_04.png 460w", "/en/static/c992d0bdeed623fbf0608605967c5709/3a737/Home_Assistant_04.png 897w"],
              "sizes": "(max-width: 897px) 100vw, 897px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/c992d0bdeed623fbf0608605967c5709/3a737/Home_Assistant_04.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Back on the Home Assistant go into the `}<strong parentName="p">{`Settings`}</strong>{` menu and open the `}<strong parentName="p">{`Devices & Services`}</strong>{` tab:`}</p>
    <p><img parentName="p" {...{
        "src": "./Home_Assistant_5.png",
        "alt": "Home Assistant with Docker"
      }}></img></p>
    <p>{`Here we can now add a new `}<strong parentName="p">{`ONVIF Integration`}</strong>{`:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/27c5f7b654ffb714aa4fc4c46ff8f3c2/33d1d/Home_Assistant_06.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "34.78260869565217%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAAAsTAAALEwEAmpwYAAABTUlEQVQoz02QW27bMBQFvYDY4psUHyJl2U1S2G1SGEWR/e9rAhJK0I8DEgQxd+45hBAptdG2K3k9Y2PCxYSxHqctLmRcWpn9TI2J6Dx5jnjjiCFilcFogzUW6wOHFDPznDDOo33AzolQlnEXUiGFQu9Rk0QJiRQSJRWqv0mFVhqlNFIbDrEDwowxdkDtHEl1Zdkuu6lDd4v/Yx1CKE6nialnEkxSMSnNwVtPzgXr/ID2KT4l7m/v3P882J5fqG1lrY11qbTauFyv4/+xw4RE9CiN6IYlZbqlMQ5t7FAPMfH89mD99aDd3tl+3tleb2wvNy6vd37cfo9KjrvZqOYLWMtC79EZhzVuTMtl4e+/D9r5QloqqbY9K7nX0c5o63iaBCchh+X3yttS2UplmRPeeJTUOBfGmh2cSyHlQupnH97flooylqfTNCyPO7jnE3ajs7P2qbvGAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/27c5f7b654ffb714aa4fc4c46ff8f3c2/e4706/Home_Assistant_06.avif 230w", "/en/static/27c5f7b654ffb714aa4fc4c46ff8f3c2/d1af7/Home_Assistant_06.avif 460w", "/en/static/27c5f7b654ffb714aa4fc4c46ff8f3c2/7f308/Home_Assistant_06.avif 920w", "/en/static/27c5f7b654ffb714aa4fc4c46ff8f3c2/d31ba/Home_Assistant_06.avif 1150w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/27c5f7b654ffb714aa4fc4c46ff8f3c2/a0b58/Home_Assistant_06.webp 230w", "/en/static/27c5f7b654ffb714aa4fc4c46ff8f3c2/bc10c/Home_Assistant_06.webp 460w", "/en/static/27c5f7b654ffb714aa4fc4c46ff8f3c2/966d8/Home_Assistant_06.webp 920w", "/en/static/27c5f7b654ffb714aa4fc4c46ff8f3c2/7ed5b/Home_Assistant_06.webp 1150w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/27c5f7b654ffb714aa4fc4c46ff8f3c2/81c8e/Home_Assistant_06.png 230w", "/en/static/27c5f7b654ffb714aa4fc4c46ff8f3c2/08a84/Home_Assistant_06.png 460w", "/en/static/27c5f7b654ffb714aa4fc4c46ff8f3c2/c0255/Home_Assistant_06.png 920w", "/en/static/27c5f7b654ffb714aa4fc4c46ff8f3c2/33d1d/Home_Assistant_06.png 1150w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/27c5f7b654ffb714aa4fc4c46ff8f3c2/c0255/Home_Assistant_06.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/d5eb84aec60eea1dc9b2e55ce96ef1eb/dc61a/Home_Assistant_07a.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "30%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAAAsTAAALEwEAmpwYAAABI0lEQVQY0z2RyY7kIBAF6z5TixcgMeCtCoNdLvWc5gv6/38pWsZSH0IPcQi9zLwMYSC4gCiDahRNqwgh4OOG/P9G1n8YEUznClos1vmSt6rm+qi4V/VJ3XCZXOCgF4duNMZY9s8Xn/3DvmbWnBnnJ9PzxRwX5ldk2z/l7/ao+HO98fd2L1zvDy69FgYteC2lpT2E752cN14xkdJK3t6kdSOmTEyJZ1zw/VBaKiMFbYRW6UNoGbTFa1uEoi0xv8lpJS2Z+FqISyrNDkkh9DgfyjsM4292zp8NgxY6bTFKMMoQ8hfT9GQeZ7wL2M4VOh9+cf1Iqwx1o6jbg5bq2KE9mh3jakEfh1FCZzusdIixZ9qOcZqLVKxFnMf0UxnxlJ3HrJuWH9JDnoVjOkO9AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/d5eb84aec60eea1dc9b2e55ce96ef1eb/e4706/Home_Assistant_07a.avif 230w", "/en/static/d5eb84aec60eea1dc9b2e55ce96ef1eb/d1af7/Home_Assistant_07a.avif 460w", "/en/static/d5eb84aec60eea1dc9b2e55ce96ef1eb/7f308/Home_Assistant_07a.avif 920w", "/en/static/d5eb84aec60eea1dc9b2e55ce96ef1eb/5d713/Home_Assistant_07a.avif 1147w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/d5eb84aec60eea1dc9b2e55ce96ef1eb/a0b58/Home_Assistant_07a.webp 230w", "/en/static/d5eb84aec60eea1dc9b2e55ce96ef1eb/bc10c/Home_Assistant_07a.webp 460w", "/en/static/d5eb84aec60eea1dc9b2e55ce96ef1eb/966d8/Home_Assistant_07a.webp 920w", "/en/static/d5eb84aec60eea1dc9b2e55ce96ef1eb/f8f9f/Home_Assistant_07a.webp 1147w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/d5eb84aec60eea1dc9b2e55ce96ef1eb/81c8e/Home_Assistant_07a.png 230w", "/en/static/d5eb84aec60eea1dc9b2e55ce96ef1eb/08a84/Home_Assistant_07a.png 460w", "/en/static/d5eb84aec60eea1dc9b2e55ce96ef1eb/c0255/Home_Assistant_07a.png 920w", "/en/static/d5eb84aec60eea1dc9b2e55ce96ef1eb/dc61a/Home_Assistant_07a.png 1147w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/d5eb84aec60eea1dc9b2e55ce96ef1eb/c0255/Home_Assistant_07a.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`The auto-discovery should find your camera automatically. Otherwise, select to add the ONVIF camera manually:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/384c9ffd914df1416ea3291776486857/0940f/Home_Assistant_07b.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "51.73913043478261%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVQoz02SyXIjIRAFdfeoVyiggV4k9aK2LNme//+2nABpPHPIIIJD8l4VB2McXeiJ44QfRnQXkM6jxXKeTqzzyrq+c51XRh9xWuisQ5TgjEO3Gt0qlNJoYzkEH/E+IMahjEU7j419lt7uD76/fvP58eB23TFKU5c1Td08qV7UDXXTUrWKg7MdznX5hVYLyrosND4yzQvzujFfFoY4UJcVxbGgKKoXZaYsK8q6oWxaDkYbus4jYmiVpkliY2iN5bSsLNc9cz6dc80qScuaoqopkqiqqRJ/E/Y+kGpnYasyKiUVk9Nt77fMZVnRYqhTkvolTNQN1f+Vh9jju4BRgk4Jm/aJ9Uz7nXlZmLcr02WmFZMl5Ut2fJ3pgZ/KpxA5h54hS58pkzgtaVmv7PvO9qrtQsT5kOu9HQveijLzqyg5JsqKQy+WQSxRHJ02GOnoxxnnHNv+wX7/Zr9/cn88OJ0vXOaZzof8Rf5h8qlEktAxiCOIw2mDiOeyfecxTMvOtH0wbTfGZWNad8btneF0ZhgnQj/8EPsBH+IzYRRLJxYrDtWmTSexw7mAdQGTxuFjRqYFZX1eQvP6FU9UvvsDopwC81CGQU4AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/384c9ffd914df1416ea3291776486857/e4706/Home_Assistant_07b.avif 230w", "/en/static/384c9ffd914df1416ea3291776486857/d1af7/Home_Assistant_07b.avif 460w", "/en/static/384c9ffd914df1416ea3291776486857/7f308/Home_Assistant_07b.avif 920w", "/en/static/384c9ffd914df1416ea3291776486857/67819/Home_Assistant_07b.avif 1154w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/384c9ffd914df1416ea3291776486857/a0b58/Home_Assistant_07b.webp 230w", "/en/static/384c9ffd914df1416ea3291776486857/bc10c/Home_Assistant_07b.webp 460w", "/en/static/384c9ffd914df1416ea3291776486857/966d8/Home_Assistant_07b.webp 920w", "/en/static/384c9ffd914df1416ea3291776486857/e3efe/Home_Assistant_07b.webp 1154w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/384c9ffd914df1416ea3291776486857/81c8e/Home_Assistant_07b.png 230w", "/en/static/384c9ffd914df1416ea3291776486857/08a84/Home_Assistant_07b.png 460w", "/en/static/384c9ffd914df1416ea3291776486857/c0255/Home_Assistant_07b.png 920w", "/en/static/384c9ffd914df1416ea3291776486857/0940f/Home_Assistant_07b.png 1154w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/384c9ffd914df1416ea3291776486857/c0255/Home_Assistant_07b.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`And use the ONVIF user created earlier plus the local IP and ONVIF Port of your camera to add your camera:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/81a244971ba80d99ea08500eb0de864f/4ad3a/Home_Assistant_08a.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "52.17391304347826%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABsklEQVQoz12Sy27bMBBFtW9tPfgckZKRxBL1sJ12UbQoiv7/X52CVBK0XRzMgsCZ4Z2pnHH0fcAYi9KGLlfn0V4KRgTjPEYZrDKoVlE3Lee6KdR1Q9O0NJ2iUZoq9gGRN6HSB8YiIbLd7uyPV7bHg2XdmOfENM1YL5yysOkKTdvRvgsv44UhDlht0crQdao8Oi/cX78wLyvXlJiWlSmtpGXFS8/nImwLdXtI605RPQ8XnuLIKKFI84TWOqQPrNvOsu28TPNBnjAtZcJPp3ORZo5pjwbVaIWLEwYriPFY7XCuR0RY151tu3GdUyFLn6/Xkunprwn/phqt52L9IdQW50bS7QcxBLb1xjQl5nlhTsuHNA4jfY7JS8lbGfNWLVWWZWmwgrd5mxbterwEbtutyKb81bfv5kx9H0rO5Sq0pcuLdIIeX6iySIpM8MajjUfJQAyR+35nW3dSWv6hD7FknUVdkZpDnrfs8o1ZhzEHKm/bR0QiX7//4tvP37wsO0/zynNamfYHEsci+J8itE6QPpau2jjaVnGuO5TKtzjg+1iqhLFU9zTTWc/pXH8c9zunuuYPmhQER/iuHPwAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/81a244971ba80d99ea08500eb0de864f/e4706/Home_Assistant_08a.avif 230w", "/en/static/81a244971ba80d99ea08500eb0de864f/d1af7/Home_Assistant_08a.avif 460w", "/en/static/81a244971ba80d99ea08500eb0de864f/7f308/Home_Assistant_08a.avif 920w", "/en/static/81a244971ba80d99ea08500eb0de864f/b019a/Home_Assistant_08a.avif 1152w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/81a244971ba80d99ea08500eb0de864f/a0b58/Home_Assistant_08a.webp 230w", "/en/static/81a244971ba80d99ea08500eb0de864f/bc10c/Home_Assistant_08a.webp 460w", "/en/static/81a244971ba80d99ea08500eb0de864f/966d8/Home_Assistant_08a.webp 920w", "/en/static/81a244971ba80d99ea08500eb0de864f/b2d4b/Home_Assistant_08a.webp 1152w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/81a244971ba80d99ea08500eb0de864f/81c8e/Home_Assistant_08a.png 230w", "/en/static/81a244971ba80d99ea08500eb0de864f/08a84/Home_Assistant_08a.png 460w", "/en/static/81a244971ba80d99ea08500eb0de864f/c0255/Home_Assistant_08a.png 920w", "/en/static/81a244971ba80d99ea08500eb0de864f/4ad3a/Home_Assistant_08a.png 1152w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/81a244971ba80d99ea08500eb0de864f/c0255/Home_Assistant_08a.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/8470f28612f32329146128b29b00dbd3/fe9e8/Home_Assistant_08b.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "30.869565217391305%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAAAsTAAALEwEAmpwYAAABHElEQVQY01WRyXLbMBAFeXZJJol9I0BING1K8pb8/7e1i5BSSQ5d79bzZqabcyGnjDcOLTVCKISQuJQ53b6JdcGFiIuJaa7kuaK04dgPHIex8TyM9KOgF5KuxkQNiewCVluUVGitKWXm6+OT6/XG63ZhWV9Z3zYut3e0dTwdjhz6gcNzz7Hv7wP6gW7SjmwcyTi8MjiXKXVjSom37crpvHBeVqYy42MipKk1FkozCMko5D3lPbtiPDvJeNxDWNcPSi78+v7NZbuyvKzM9dSkYZfGCWUsUpv/EErR/WkXdqHxKKkZhSKGxHJ+4fxgl+7CWCrGh3bnveVfVGvbeeuxxjWMsmjrCbkQfMRZ37DuH1Jpq8eY2nN2mXwgpOIHiNebj6KSSggAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/8470f28612f32329146128b29b00dbd3/e4706/Home_Assistant_08b.avif 230w", "/en/static/8470f28612f32329146128b29b00dbd3/d1af7/Home_Assistant_08b.avif 460w", "/en/static/8470f28612f32329146128b29b00dbd3/7f308/Home_Assistant_08b.avif 920w", "/en/static/8470f28612f32329146128b29b00dbd3/bccf5/Home_Assistant_08b.avif 1146w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/8470f28612f32329146128b29b00dbd3/a0b58/Home_Assistant_08b.webp 230w", "/en/static/8470f28612f32329146128b29b00dbd3/bc10c/Home_Assistant_08b.webp 460w", "/en/static/8470f28612f32329146128b29b00dbd3/966d8/Home_Assistant_08b.webp 920w", "/en/static/8470f28612f32329146128b29b00dbd3/b28d4/Home_Assistant_08b.webp 1146w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/8470f28612f32329146128b29b00dbd3/81c8e/Home_Assistant_08b.png 230w", "/en/static/8470f28612f32329146128b29b00dbd3/08a84/Home_Assistant_08b.png 460w", "/en/static/8470f28612f32329146128b29b00dbd3/c0255/Home_Assistant_08b.png 920w", "/en/static/8470f28612f32329146128b29b00dbd3/fe9e8/Home_Assistant_08b.png 1146w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/8470f28612f32329146128b29b00dbd3/c0255/Home_Assistant_08b.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`After saving your settings the camera with all it's ONVIF features should be added to the Home Assistant dashboard:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/039f62c70daaac8010eb2283756b9bb9/2d2d6/Home_Assistant_08c.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "77.39130434782608%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAAsTAAALEwEAmpwYAAACo0lEQVQ4y1WUSXLrNhRFuYOY0rdIgugBoiEl2Yrz0w4zzyz7X8pJAXKS8uAWqkDgvoPXcPAukFJhywUXN1bjUC5gfGRZVsS8sM4LchaoWfS17S3TV83zgpCKIadCDBtSKlapuCyC02X+1MTp/I3TeOL8cuI8np86fWo892+vrxeutzvXt3eG0Ai3jJKadZUYF9jvd2KpCGMR2vTItVSccYhF9HONPqXc1WC0sSjrGUoMlJTR2rIsAh8i97d3jA+s2iA/TWPee2CtDKXsWB/Y6pWQD2IqlH3Hb5nh43ZQcnk+Waw456l1J5eKto5VaRapcTHhvO8kpe49oNsKoV7J9eh7NkSGx7Gz50q0HrMqoo+9SI1YKo1qhC2Yi8iYke3cZyCfKm6rnSyVVtTIsIfAHjaqCwRl0coiTESssquRLy23W2ZxkVkqZrEyLYKQCm7LWB+x3qO0YUjasilLW5uhN568ZYKPz/YwkUUaSj2IcUNI2ekatQkJl3ZirqRcOvmQtaMpGYeVhpoqv//2Bz9//4XH24NtK6zKEMu151Vq00laLlMLUo7ev62YbW+IxhG0w2uH7U82GOMwLYerYrrMaOO43e+EELthz602vVir8b1dGt0iVoZ2WbeoyiKlJoSN+/0d7yLeOky+MreLNvR8KaX7ALTLP7yMvIynLxoaZjNp0ddV4Xzk8fjg2K/U1g4pI8TKbDcmlxHK9EJN89INxtP5iwZx/Qn19iv6+JEpHMj2dOOYZ8EyL0zKMQvVK+l6Pm2f28s0MXbD/007obTPBtW+VdZQc+bj4zvHceN2vVFuj16UNh173fuIimYqZDdsJq+XiW+vl6fhn3/9TW2jZDzRrDitiTF1SqUMuk3KIrEhs22Z9neSPjFJyziO/5H9+/x/AATdmim2ksEsAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/039f62c70daaac8010eb2283756b9bb9/e4706/Home_Assistant_08c.avif 230w", "/en/static/039f62c70daaac8010eb2283756b9bb9/d1af7/Home_Assistant_08c.avif 460w", "/en/static/039f62c70daaac8010eb2283756b9bb9/7f308/Home_Assistant_08c.avif 920w", "/en/static/039f62c70daaac8010eb2283756b9bb9/b423c/Home_Assistant_08c.avif 1205w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/039f62c70daaac8010eb2283756b9bb9/a0b58/Home_Assistant_08c.webp 230w", "/en/static/039f62c70daaac8010eb2283756b9bb9/bc10c/Home_Assistant_08c.webp 460w", "/en/static/039f62c70daaac8010eb2283756b9bb9/966d8/Home_Assistant_08c.webp 920w", "/en/static/039f62c70daaac8010eb2283756b9bb9/9fb66/Home_Assistant_08c.webp 1205w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/039f62c70daaac8010eb2283756b9bb9/81c8e/Home_Assistant_08c.png 230w", "/en/static/039f62c70daaac8010eb2283756b9bb9/08a84/Home_Assistant_08c.png 460w", "/en/static/039f62c70daaac8010eb2283756b9bb9/c0255/Home_Assistant_08c.png 920w", "/en/static/039f62c70daaac8010eb2283756b9bb9/2d2d6/Home_Assistant_08c.png 1205w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/039f62c70daaac8010eb2283756b9bb9/c0255/Home_Assistant_08c.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/d1c85b767c95d20981473f83dfa247a8/e72de/Home_Assistant_08d.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "68.26086956521739%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC2UlEQVQ4y0XSy4sdRRTH8buNmsx0VXX37a5HV1W/bt87d8ZMokYniSsfOIqiJkQIJkHwBYIgGnQXFILuBEHEjQtBEMSde/8J1+I/8pWuGTKLHwea4sM5p8/Cx55xs896e0AYVyzHPfTmIlnTI2yHMhFlWgrbUrouJbct0kQyHRE6omxH1U1Uw4aF2T6D3lymXu1Tj1tUbZDLGlFWyKKkNg7fBKy2mNqk6DnaEH1kWVZkmUTKHJmXLPpuIPiI1hZtHapcIsol8rS6EPE+PMJS5rfaME9X1QaRCZSawYJFFyLraZMezJk/irw4AfOCcW/LtLfFGJe6TLEO5xxh/ynqOCYwL8rUzGK7GmljdwZKRSYkQqmEV87TT2tC26HNjDUJ9G3HMI7UxiBkfgYebNaMwwpnHM5Y1Cl4guaYJhC7HuMatGswjce6hiZE2mFFZSyZVKh5qqJksR1HtuPE4CPBNuSqSEtOoFTYMDBOa2LXUduTPRvnUvWxpdKG3dOJ5gYWwzySbRhdoHWeZV4iZzATCKHQNtAPE74dWGpLZVyqS22wTaCsNDuZIJMyZTG4kLC5RuspZ1CotGgpJM41DH3L0wcr+tDQOM0QHY0zjGOPsfYROHeaOpzTuUBwM7hM4IwVUnL9wPLhayv++eYFfv/qmC/vXuLB3Ys8eO8a335xi5tvv8i5Jy6kkTMhWMQmEJqAd4HGeorTDrNMscwVN48CP99/lX+/u81/v37Abz++y/efvMTX71/n8ztHvHxtj8fOZ4h55Bm0jcekUziJUkUCd3cltip552rHw4/f4O9fPuOvn97kzz/u8cPDudMr3L99heNnO86d3z0DfWhZTRti26ONS6DIZPohQkis2uFoqvn0zlWOjyNv3Zi499ElXn/lkOefbHjusOXxCydg2mHb9oyrNdb5dLhKnoEzfrge2fSey61h7TWjr1i3jlXnmXqP0RU7u+L0dgX/A+avjNoBoUSKAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/d1c85b767c95d20981473f83dfa247a8/e4706/Home_Assistant_08d.avif 230w", "/en/static/d1c85b767c95d20981473f83dfa247a8/d1af7/Home_Assistant_08d.avif 460w", "/en/static/d1c85b767c95d20981473f83dfa247a8/7f308/Home_Assistant_08d.avif 920w", "/en/static/d1c85b767c95d20981473f83dfa247a8/b84c5/Home_Assistant_08d.avif 1198w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/d1c85b767c95d20981473f83dfa247a8/a0b58/Home_Assistant_08d.webp 230w", "/en/static/d1c85b767c95d20981473f83dfa247a8/bc10c/Home_Assistant_08d.webp 460w", "/en/static/d1c85b767c95d20981473f83dfa247a8/966d8/Home_Assistant_08d.webp 920w", "/en/static/d1c85b767c95d20981473f83dfa247a8/40d0b/Home_Assistant_08d.webp 1198w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/d1c85b767c95d20981473f83dfa247a8/81c8e/Home_Assistant_08d.png 230w", "/en/static/d1c85b767c95d20981473f83dfa247a8/08a84/Home_Assistant_08d.png 460w", "/en/static/d1c85b767c95d20981473f83dfa247a8/c0255/Home_Assistant_08d.png 920w", "/en/static/d1c85b767c95d20981473f83dfa247a8/e72de/Home_Assistant_08d.png 1198w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/d1c85b767c95d20981473f83dfa247a8/c0255/Home_Assistant_08d.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h2 {...{
      "id": "control-your-camera-through-mqtt",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#control-your-camera-through-mqtt",
        "aria-label": "control your camera through mqtt permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Control your Camera through MQTT`}</h2>
    <h3 {...{
      "id": "connect-your-mqtt-broker",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#connect-your-mqtt-broker",
        "aria-label": "connect your mqtt broker permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Connect your MQTT Broker`}</h3>
    <p>{`To get started either connect your camera to your already configured MQTT broker. Or activate the MQTT v5 broker on your camera:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "906px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/2c3676095f81499f66af4a976a832129/6029f/Home_Assistant_09.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "88.69565217391305%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAIAAADUsmlHAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACtElEQVQ4y12SyU7bUBiF8wgIRBITERKU4AwGNggCJBDP8XXs6+FOHiKGqlIXXTK16oCQKvURQN21LFpA6pIX6INVtkkIHB15dT+f/z/35tbX11fX1pr15X70wb16NC4etLMH7exeO7tXT5+tnNwb53fs2yM5/7G0tFStVusrK7lWq9VuCyu1ZYW+jz//xKfX6OTJ+PRmYnR6w86uR19ujcOPpVKJ4xaKxWKunarRaIh7uxH1Auxgx8zsWQN3yo6phgdvZUXluMLCQqlcLucEQWi32zzPi5IchBGhDBOKCUWYuK7neX5mN/0evzk2DFDkuHK5XK/Xn+F+v+/7vud5o9Ho4ODw6OgojmPfR4RgxihjzE+l63o+n+c4rlarJbAgCEmyKIZhGARBHMfRWLZt64NEqqoqigIAkGV5bm6uWCzyPP+0cwbHcUwpxRgjhFzXdRwHQug4znA4BAAYhmHbtiiKGby4uPgCDsOQMYYQ8saCEBoG0DRN13VN0wAAkiQVCoXZ2dmZmZmpwlI4S56GJ7GDwcCyLFmWC4VCPp+fn59PkrOdJUkKo5AxGgTBJDybfDgcmqYJAIAQKopSqVSqqXKNRmO6MEopISQjXdclNPkXIYQSTCiNokhV1We42WxmY0uSNIrjrO1Jso9SYeqzEfL9IAxfw4IgJC9MFCml6VGUXbjneQhjkuQGODzEGDMWvIZXV1cnVxUEzPeTgacLM01gAgMA07btFztnyeOdI4yJO646e0+9bne70+lsb291Ot1eTxLFZ3j6eRKC/Sx3LAihZVnDVKZpQghlWX6R3Gq1avWVgSr9/Qr/fTd/XVgeIkntyKPvPsWXd+TyzxU5/g2sWxt5qrZYqSxP4GazyfP81uYm1PddfQ/Ivd3dbqrd7r7Uk0FXNuRub7CzY3R7mxsbk+T/6v8mBVK7dccAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/2c3676095f81499f66af4a976a832129/e4706/Home_Assistant_09.avif 230w", "/en/static/2c3676095f81499f66af4a976a832129/d1af7/Home_Assistant_09.avif 460w", "/en/static/2c3676095f81499f66af4a976a832129/f5e2f/Home_Assistant_09.avif 906w"],
              "sizes": "(max-width: 906px) 100vw, 906px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/2c3676095f81499f66af4a976a832129/a0b58/Home_Assistant_09.webp 230w", "/en/static/2c3676095f81499f66af4a976a832129/bc10c/Home_Assistant_09.webp 460w", "/en/static/2c3676095f81499f66af4a976a832129/45005/Home_Assistant_09.webp 906w"],
              "sizes": "(max-width: 906px) 100vw, 906px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/2c3676095f81499f66af4a976a832129/81c8e/Home_Assistant_09.png 230w", "/en/static/2c3676095f81499f66af4a976a832129/08a84/Home_Assistant_09.png 460w", "/en/static/2c3676095f81499f66af4a976a832129/6029f/Home_Assistant_09.png 906w"],
              "sizes": "(max-width: 906px) 100vw, 906px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/2c3676095f81499f66af4a976a832129/6029f/Home_Assistant_09.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Back on the Home Assistant go into the `}<strong parentName="p">{`Settings`}</strong>{` menu and open the `}<strong parentName="p">{`Devices & Services`}</strong>{` tab:`}</p>
    <p><img parentName="p" {...{
        "src": "./Home_Assistant_5.png",
        "alt": "Home Assistant with Docker"
      }}></img></p>
    <p>{`Here we can now add a new `}<strong parentName="p">{`MQTT Integration`}</strong>{`:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/dc2582b6e2506e0455d077f4d9a1febb/b94e3/Home_Assistant_11.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "30.869565217391305%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAIAAABM9SnKAAAACXBIWXMAAA7rAAAO6wFxzYGVAAAA/ElEQVQY012O2WrDQAxF/T2xJzOaVbN4vKXxEicha50+lf7/RxTbpZTCRSDQ0bkJSKcwoq+MLZiwID0TlnEk2qcYqHTS5EzYv5NypByZsIk0ucIoTVh3IS1IR7klYAg3W/gJYXoLZsXWgHSJ0EFhXABMmcnyvm7PTXvO64MrWl92vuxc0eX1ILDImJ6fgpkvqU4URqHDWjWlSuZv19fXdfo8XD6a4bYb7rvh3vS3/vxyZZsyvRWYMvTBUl/PtY0rhQ6LWUM1DOPUHp9Nf/1N3V32x6eN+w1V2aIFZYj0CfpKYVzNG9C8Po1u6k7v/+HxYeM+ZZpwJBwzQALmG/YpUrD/wxcRAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/dc2582b6e2506e0455d077f4d9a1febb/e4706/Home_Assistant_11.avif 230w", "/en/static/dc2582b6e2506e0455d077f4d9a1febb/d1af7/Home_Assistant_11.avif 460w", "/en/static/dc2582b6e2506e0455d077f4d9a1febb/7f308/Home_Assistant_11.avif 920w", "/en/static/dc2582b6e2506e0455d077f4d9a1febb/bedb6/Home_Assistant_11.avif 1126w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/dc2582b6e2506e0455d077f4d9a1febb/a0b58/Home_Assistant_11.webp 230w", "/en/static/dc2582b6e2506e0455d077f4d9a1febb/bc10c/Home_Assistant_11.webp 460w", "/en/static/dc2582b6e2506e0455d077f4d9a1febb/966d8/Home_Assistant_11.webp 920w", "/en/static/dc2582b6e2506e0455d077f4d9a1febb/65db1/Home_Assistant_11.webp 1126w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/dc2582b6e2506e0455d077f4d9a1febb/81c8e/Home_Assistant_11.png 230w", "/en/static/dc2582b6e2506e0455d077f4d9a1febb/08a84/Home_Assistant_11.png 460w", "/en/static/dc2582b6e2506e0455d077f4d9a1febb/c0255/Home_Assistant_11.png 920w", "/en/static/dc2582b6e2506e0455d077f4d9a1febb/b94e3/Home_Assistant_11.png 1126w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/dc2582b6e2506e0455d077f4d9a1febb/c0255/Home_Assistant_11.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`And add your camera's IP address and the MQTT port and user you configured in your camera in the beginning:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/c608e33667a28f63af9a3fc819557020/76a99/Home_Assistant_12.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "57.391304347826086%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAIAAADwazoUAAAACXBIWXMAAA7rAAAO6wFxzYGVAAABYElEQVQoz3XSaW6DMBQE4BwnAQIxGNuEJRsGG3AIYJaoVZf7X6ICp1ZSqdKIf59meLDySQJx7KHIBhiSQzN+yvt3O34Vt/ucen7yekqLNhdjeGSbrWs6/sbyNpa3gjhGQeL6oQ2wi2JeT7yeaCmzqs+qPl+SVf2Ft7SU4ZGZAFuArE13bborFCQeinZeoLHo3nMxZFVPS3lmjcqFN2khw0NuONDcoQeGOPZJssxGHooX06XFIxfeqpxZU9zu0YkZtm9pTMITChIA97pZ1arQUmrcjJ+HtHRg4HjBC9az2XXIxaBq1YRH+by8C4/MAnir3xnA/c4LHJfoZnYd06LLqv7PbFrK6PSKbYAdl2ici4Fdx+Xa8hlfeJOLITrzLQy27u9sJRWeD1Y+zKucMa+n8MgM5+lgz3iZPdb9h/ox1OfVSYuOxNRwfPM/zMQo2rdcDLSU+tQqtJAkphZAFsAK/wAeLaW/JyDzuwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/c608e33667a28f63af9a3fc819557020/e4706/Home_Assistant_12.avif 230w", "/en/static/c608e33667a28f63af9a3fc819557020/d1af7/Home_Assistant_12.avif 460w", "/en/static/c608e33667a28f63af9a3fc819557020/7f308/Home_Assistant_12.avif 920w", "/en/static/c608e33667a28f63af9a3fc819557020/88d8d/Home_Assistant_12.avif 1117w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/c608e33667a28f63af9a3fc819557020/a0b58/Home_Assistant_12.webp 230w", "/en/static/c608e33667a28f63af9a3fc819557020/bc10c/Home_Assistant_12.webp 460w", "/en/static/c608e33667a28f63af9a3fc819557020/966d8/Home_Assistant_12.webp 920w", "/en/static/c608e33667a28f63af9a3fc819557020/faa4b/Home_Assistant_12.webp 1117w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/c608e33667a28f63af9a3fc819557020/81c8e/Home_Assistant_12.png 230w", "/en/static/c608e33667a28f63af9a3fc819557020/08a84/Home_Assistant_12.png 460w", "/en/static/c608e33667a28f63af9a3fc819557020/c0255/Home_Assistant_12.png 920w", "/en/static/c608e33667a28f63af9a3fc819557020/76a99/Home_Assistant_12.png 1117w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/c608e33667a28f63af9a3fc819557020/c0255/Home_Assistant_12.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`For 2K+ WQHD models it is also possible to use MQTT v5 for the connection that can be configured in the advanced settings:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/1bcbb91309087b235a67c7e64d795b33/76a99/Home_Assistant_13.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "67.3913043478261%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAA7rAAAO6wFxzYGVAAABzUlEQVQoz22S6Y6jMBCE52l2sgmXDcY2ZxLAmMucBnIo7/8YuzMmaDVaqdT/PndVtT8QiVwaQeQbAEMUcDFzsbBacjGzekqKISmGK++5WJrxScLsaDgn0z2c4OEEPxCJsBfbbmAAF6Igq6a0HLNquvJekUkxXPKO1bIeHjRmGsA6IBuMvTMioWVTA2CAgqq7dfOrGR6slqyWuZrNnFVTLhb/wgHyTMd7b6aRgzcYoiBv5qJd02JIyzEtp++5idWSxuxoIg3gDTYANiH5EsDA8av+XvW3slvTcky2JzZxsfhnbjrUsN+2NxISZZs3cz3cm/EhpmfVrXkj80ZysRTtysVK41yHWIf/gyEKyu7WypcYn618cTHvbV/yjovFi/Pf+j9tb+S+WSxVd+Ni4WJRbSn/SdGzWnpxfrJcfc8MIIE2tZFvAgIcX2FqoYq6H4w1M/0Ba14Ew4sTXTUcmDhUmYv2K+R3zmWHs2ryfmQ+0cDyIpOEGqIWDpTnK++VdjIpBt7MJEw/T9ZRt9+fBJ8xiVwcmZYLkc8aWXa3t9aqv7NaJuWYFkPWLjjMfh3Mg/aGHXSBKLBs+l0bpXHunwv/zHd5u5LSQsHn0VLkX/gPFDXC6EPkxuMAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/1bcbb91309087b235a67c7e64d795b33/e4706/Home_Assistant_13.avif 230w", "/en/static/1bcbb91309087b235a67c7e64d795b33/d1af7/Home_Assistant_13.avif 460w", "/en/static/1bcbb91309087b235a67c7e64d795b33/7f308/Home_Assistant_13.avif 920w", "/en/static/1bcbb91309087b235a67c7e64d795b33/88d8d/Home_Assistant_13.avif 1117w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/1bcbb91309087b235a67c7e64d795b33/a0b58/Home_Assistant_13.webp 230w", "/en/static/1bcbb91309087b235a67c7e64d795b33/bc10c/Home_Assistant_13.webp 460w", "/en/static/1bcbb91309087b235a67c7e64d795b33/966d8/Home_Assistant_13.webp 920w", "/en/static/1bcbb91309087b235a67c7e64d795b33/faa4b/Home_Assistant_13.webp 1117w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/1bcbb91309087b235a67c7e64d795b33/81c8e/Home_Assistant_13.png 230w", "/en/static/1bcbb91309087b235a67c7e64d795b33/08a84/Home_Assistant_13.png 460w", "/en/static/1bcbb91309087b235a67c7e64d795b33/c0255/Home_Assistant_13.png 920w", "/en/static/1bcbb91309087b235a67c7e64d795b33/76a99/Home_Assistant_13.png 1117w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/1bcbb91309087b235a67c7e64d795b33/c0255/Home_Assistant_13.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Submit your changes and Home Assistant will connect to your INSTAR MQTT broker:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/3914cb10cc887a68d98efa1a5a1e4391/73caa/Home_Assistant_14.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "68.69565217391305%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAIAAACgpqunAAAACXBIWXMAAA7rAAAO6wFxzYGVAAABn0lEQVQoz22S247aMBCGeZmyIbZje+zx2UkILGU5SO2y3V7Qi970/V+hCsmyAVb6ZFmWPnnmn5kpk1xchrxCV3NwQnkOjgkzUEn7JRwcBzfTNqPLg1My/VTKBVUcPAdfgSMcHykrXRAoCMyUScOfUxnT0ubO12uBkSrPbqHSjjK6GjDeyEQ9STMHOxeGCKTC3EE4jrK2yfjmpmymMLQ2tC4uwSQqLQPHpGXS0gtEmFE2oUWXpz8XBARGrgPXoVJuEBg4gf2LNIlrP8o2NNqmqUy5Rd+a2OnQSpPB1mBrgbFSnoHrz2vPUvuhZg6OVPpbwXP38vvPv8PrebN/W+1O3fbnZv+Wux2VtlK+mgY2aFO5Xu1/vP89ns6H03lz+LV6eX0+vtfrA1deYOxLAPeFXDI9Xwhlm9huffM9NNu43KVuFzdHTGsizH1gd/IQmMTYYyID1zscex5HVYG7btx1VMpm7WsMrcQ4jmoCFR89g/Lohg393DCBAUxSNvNLwmPI48V9BlbWS92uaayJzwuORSkLqqpLNlwH+rEYXIdH+T+iqqqjdXPMigAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/3914cb10cc887a68d98efa1a5a1e4391/e4706/Home_Assistant_14.avif 230w", "/en/static/3914cb10cc887a68d98efa1a5a1e4391/d1af7/Home_Assistant_14.avif 460w", "/en/static/3914cb10cc887a68d98efa1a5a1e4391/7f308/Home_Assistant_14.avif 920w", "/en/static/3914cb10cc887a68d98efa1a5a1e4391/a53e8/Home_Assistant_14.avif 1110w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/3914cb10cc887a68d98efa1a5a1e4391/a0b58/Home_Assistant_14.webp 230w", "/en/static/3914cb10cc887a68d98efa1a5a1e4391/bc10c/Home_Assistant_14.webp 460w", "/en/static/3914cb10cc887a68d98efa1a5a1e4391/966d8/Home_Assistant_14.webp 920w", "/en/static/3914cb10cc887a68d98efa1a5a1e4391/f9357/Home_Assistant_14.webp 1110w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/3914cb10cc887a68d98efa1a5a1e4391/81c8e/Home_Assistant_14.png 230w", "/en/static/3914cb10cc887a68d98efa1a5a1e4391/08a84/Home_Assistant_14.png 460w", "/en/static/3914cb10cc887a68d98efa1a5a1e4391/c0255/Home_Assistant_14.png 920w", "/en/static/3914cb10cc887a68d98efa1a5a1e4391/73caa/Home_Assistant_14.png 1110w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/3914cb10cc887a68d98efa1a5a1e4391/c0255/Home_Assistant_14.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/b11814597e9df907fe225637c9055c5f/62a6a/Home_Assistant_15.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "37.826086956521735%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAIAAAB2/0i6AAAACXBIWXMAAA7rAAAO6wFxzYGVAAABDElEQVQY033Px07EMBCAYb8RF267aR47cS9jp29hJcSR9z9CWBSkFSB9138K8fncz7c0XludW53jcJFuBBmZQiYRRNwxiQ+IxVW5katEu1CBrcEVVFeNKakuwTStv6u5K8E8IKG/CDtwlarWJf/yJt71U++eZwbINI6n1zzf4nj1+URFBIkgkaoNbJvj0urMVQIRlZuMX7hIILarmi7ItHZpqWSk3XcJEms3NLbnKhGfTsqN9/dUmGxaucn068O6C2UYGtMzlZhKe7wjBpdu3xwmi6uJC0iUfirAHJkpQBf0d8Tiz9k6LjatOs50GzQfG3Uou0Mt/0J0mPfY4OL7cxwuLq8gsaD6n/Iz/gDL7ItrK5BofgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/b11814597e9df907fe225637c9055c5f/e4706/Home_Assistant_15.avif 230w", "/en/static/b11814597e9df907fe225637c9055c5f/d1af7/Home_Assistant_15.avif 460w", "/en/static/b11814597e9df907fe225637c9055c5f/7f308/Home_Assistant_15.avif 920w", "/en/static/b11814597e9df907fe225637c9055c5f/9b5ba/Home_Assistant_15.avif 1122w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/b11814597e9df907fe225637c9055c5f/a0b58/Home_Assistant_15.webp 230w", "/en/static/b11814597e9df907fe225637c9055c5f/bc10c/Home_Assistant_15.webp 460w", "/en/static/b11814597e9df907fe225637c9055c5f/966d8/Home_Assistant_15.webp 920w", "/en/static/b11814597e9df907fe225637c9055c5f/e6b69/Home_Assistant_15.webp 1122w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/b11814597e9df907fe225637c9055c5f/81c8e/Home_Assistant_15.png 230w", "/en/static/b11814597e9df907fe225637c9055c5f/08a84/Home_Assistant_15.png 460w", "/en/static/b11814597e9df907fe225637c9055c5f/c0255/Home_Assistant_15.png 920w", "/en/static/b11814597e9df907fe225637c9055c5f/62a6a/Home_Assistant_15.png 1122w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/b11814597e9df907fe225637c9055c5f/c0255/Home_Assistant_15.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h3 {...{
      "id": "add-mqtt-topics-to-the-home-assistant-ui",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#add-mqtt-topics-to-the-home-assistant-ui",
        "aria-label": "add mqtt topics to the home assistant ui permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Add MQTT Topics to the Home Assistant UI`}</h3>
    <p>{`Now you have access to your camera's entire `}<a parentName="p" {...{
        "href": "/en/Advanced_User/INSTAR_MQTT_Broker/MQTTv5_API/"
      }}>{`MQTT interface`}</a>{` and can bind functions to switches, buttons or number read-outs. This has already been described in an `}<a parentName="p" {...{
        "href": "/en/Frequently_Asked_Question/Home_Assistant_INSTAR_WQHD_MQTTv5_Camera_Control/#turn-your-mqtt-topics-into-switches"
      }}>{`FAQ :: Home Assistant 2022.8.6 Configuration for your WQHD INSTAR MQTTv5 Broker`}</a>{`.`}</p>
    <h4 {...{
      "id": "declare-the-camera-mqtt-device",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#declare-the-camera-mqtt-device",
        "aria-label": "declare the camera mqtt device permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Declare the Camera MQTT Device`}</h4>
    <p>{`If you followed the installation path described above you will now be able to find the main configuration file in `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/opt/homeassistant/config/configuration.yaml`}</code>{`. Here we can add an import for Switch items that we want to use to toggle our camera state through the MQTT API:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "yaml"
    }}><pre parentName="div" {...{
        "className": "language-yaml"
      }}><code parentName="pre" {...{
          "className": "language-yaml"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`# MQTT`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# switch: !include mqtt/switches.yaml /deprecated`}</span>{`
`}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`mqtt`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token tag"
          }}>{`!include`}</span>{` mqtt/entities.yaml`}</code></pre></div>
    <p>{`Now create the mqtt folder next to the configuration file and create the file `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`entities.yaml`}</code>{` inside:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`mkdir`}</span>{` mqtt
`}<span parentName="code" {...{
            "className": "token function"
          }}>{`nano`}</span>{` mqtt/entities.yaml`}</code></pre></div>
    <p>{`Here we can create, for example, 4 switches that can toggle the privacy masks in our camera using the `}<a parentName="p" {...{
        "href": "/en/Frequently_Asked_Question/INSTAR_Command_Status_and_RAW_Topics/"
      }}>{`MQTT command topics`}</a>{`. If your set your camera to use the prefix `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`cameras`}</code>{` and the mqtt ID `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`201`}</code>{`:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/df807f4d7ffe366caddee390335bbc6a/5b587/Home_Assistant_16.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "54.347826086956516%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAIAAADwazoUAAAACXBIWXMAAA7rAAAO6wFxzYGVAAAB+0lEQVQoz02QyW6bUABF/RONwUxvJh4B2xgb8APzBozBSdWk6qat1KZSVandRIqSRaX+emU7i0hne3SHHvOvEaGYYHQ9ZfIHFj8d/t3lDy5/cN7g8gdf/6LlF91009l0YFkAwh7EBCACIEDX0/XHp9Wnv+GH5+BMePcS3r1Erzznn/8l949sOPE8r983TNPsIUzOPkaEVrK6ue10LYWqhKyKXVHuiqLkZ/JUHmKurIHR7xtGv//u6qqHCH2VKSukVoejOnS6Pcqm40JzoUu9L/W+kHqr26SQk8kYIQQAcBznJCNMPIgwZVlZ5TvBhRJ1I/dNqWpeKX3omuOtqJtCqpTz0Wjs+8zzPABAD5FTbQ/AS7I+dFW931aSC8WFWmd5tIyDxTI8EcebdDgaUUpM07Qs63TYSYZv5WZ37nmR53EczBcXVmmGCQEAMMaGw+ElGV+SS6n3baebw07XFzlJs2gZT8MoCMNZEKzTHADouq7v+4SQ82ZCIMKYsrTSmb7JZJtXkp+bZ9s8SZZxspql2TTNVjm3bduyBoQQhFAPYowpBQhBNrzXq+f37PdxLJQq1H6n1Kb9Gt8/5u23P2nxlJXHjBuOaximZTu24542Y8ogwpD6fDO/4eM6myyT9SLZLJJ1kIrZto02oo6W7TxeR4uB65kDy7Rs07L/A/8oiQIfq5XCAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/df807f4d7ffe366caddee390335bbc6a/e4706/Home_Assistant_16.avif 230w", "/en/static/df807f4d7ffe366caddee390335bbc6a/d1af7/Home_Assistant_16.avif 460w", "/en/static/df807f4d7ffe366caddee390335bbc6a/7f308/Home_Assistant_16.avif 920w", "/en/static/df807f4d7ffe366caddee390335bbc6a/87d2a/Home_Assistant_16.avif 1010w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/df807f4d7ffe366caddee390335bbc6a/a0b58/Home_Assistant_16.webp 230w", "/en/static/df807f4d7ffe366caddee390335bbc6a/bc10c/Home_Assistant_16.webp 460w", "/en/static/df807f4d7ffe366caddee390335bbc6a/966d8/Home_Assistant_16.webp 920w", "/en/static/df807f4d7ffe366caddee390335bbc6a/93852/Home_Assistant_16.webp 1010w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/df807f4d7ffe366caddee390335bbc6a/81c8e/Home_Assistant_16.png 230w", "/en/static/df807f4d7ffe366caddee390335bbc6a/08a84/Home_Assistant_16.png 460w", "/en/static/df807f4d7ffe366caddee390335bbc6a/c0255/Home_Assistant_16.png 920w", "/en/static/df807f4d7ffe366caddee390335bbc6a/5b587/Home_Assistant_16.png 1010w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/df807f4d7ffe366caddee390335bbc6a/c0255/Home_Assistant_16.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Let's first create an entity for our camera using the `}<strong parentName="p">{`Last-Will & Testament`}</strong>{` (LWT) Topic as your camera's heartbeat.`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <APIv2Box mdxType="APIv2Box" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Additionally, we can add the `}<a parentName="p" {...{
        "href": "/en/Frequently_Asked_Question/WQHD_MQTTv5_Alarmserver_Testing/"
      }}>{`MQTT alarm server`}</a>{` as a sensor to be notified every time an alarm is triggered:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "yaml"
    }}><pre parentName="div" {...{
        "className": "language-yaml"
      }}><code parentName="pre" {...{
          "className": "language-yaml"
        }}><span parentName="code" {...{
            "className": "token key atrule"
          }}>{`sensor`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`device`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
      `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`identifiers`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` in8415_office
      `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`manufacturer`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` INSTAR Deutschland GmbH
      `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`model`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` INSTAR 2k+ IN`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`8415 WLAN
      `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` IN`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`8415 2k+ Office
      `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`configuration_url`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"http://192.168.2.201:80"`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`availability`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
      `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/connection
      `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_available`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"online"}'`}</span>{`
      `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_not_available`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"offline"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`object_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` in8415_office_testament
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` in8415_office_testament
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` IN`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`8415 LWT
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/connection
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`value_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{{ value_json.val }}'`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_alarmserver
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Alarmserver
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/alarm/triggered
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`device_class`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` current
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`value_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{{ value_json.val }}'`}</span></code></pre></div>
    <p>{`Reload the configuration file and verify that the new device is now registered:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/9b5371193e6c1d73d89db0a71f440d8c/77f8f/Home_Assistant_17.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "28.260869565217394%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAIAAABM9SnKAAAACXBIWXMAAA7rAAAO6wFxzYGVAAAA4ElEQVQY02XP22qEMBAGYF9rtx5ycDQmk5iDuiZpKdKL9v2foERZWFr4GP6b4Z+plngs+8FGCzIou3PhaipfNUzVVL6R6Y+GqUrZ2E+eDvO9E3x0LUcChoCmYLpeEzBX+L9870Ql5x1koMNMwHDh6GhbMDVTDVMNx1J75pZj86LtdWnWPoEMBAz6lI6f+Pm9pi/0aV4+dHg3T7rIz5yljQRMhTZezb0MaKM0D+UiuqTXpLaIayq2My8JfUaflYs9Lh2YSp1ns2GuMdy2fFsTkYEJR4W95smxEy1/FXJyFPQvNeFosWTrKDEAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/9b5371193e6c1d73d89db0a71f440d8c/e4706/Home_Assistant_17.avif 230w", "/en/static/9b5371193e6c1d73d89db0a71f440d8c/d1af7/Home_Assistant_17.avif 460w", "/en/static/9b5371193e6c1d73d89db0a71f440d8c/7f308/Home_Assistant_17.avif 920w", "/en/static/9b5371193e6c1d73d89db0a71f440d8c/d3378/Home_Assistant_17.avif 1353w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/9b5371193e6c1d73d89db0a71f440d8c/a0b58/Home_Assistant_17.webp 230w", "/en/static/9b5371193e6c1d73d89db0a71f440d8c/bc10c/Home_Assistant_17.webp 460w", "/en/static/9b5371193e6c1d73d89db0a71f440d8c/966d8/Home_Assistant_17.webp 920w", "/en/static/9b5371193e6c1d73d89db0a71f440d8c/87c73/Home_Assistant_17.webp 1353w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/9b5371193e6c1d73d89db0a71f440d8c/81c8e/Home_Assistant_17.png 230w", "/en/static/9b5371193e6c1d73d89db0a71f440d8c/08a84/Home_Assistant_17.png 460w", "/en/static/9b5371193e6c1d73d89db0a71f440d8c/c0255/Home_Assistant_17.png 920w", "/en/static/9b5371193e6c1d73d89db0a71f440d8c/77f8f/Home_Assistant_17.png 1353w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/9b5371193e6c1d73d89db0a71f440d8c/c0255/Home_Assistant_17.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/8a370be51fabe2db40138ae34bf48586/7a18f/Home_Assistant_18.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "30.434782608695656%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAIAAABM9SnKAAAACXBIWXMAAA7rAAAO6wFxzYGVAAABB0lEQVQY0yWOOW7DMBAA9a0EcETxXp7LJSlK8gmkdZE+nw9id1MMMDO5vGG/1fFweTOhmdCUq8pVkVZGmwzN583GFfJwaUBcJdBbMKFPoRyh7Mo1CaTTANwhDQEkbJGh6ziELcIWbgq3hfuuXNX+Jbs2pXqOdCjflMUPvAu6+TxU6FxFe33i81fazKFCII7H5/cPbQ9fDpPG4l/lXC8mdAm0GOS+cYvvDrM0x5VDYRqpVV2vIjYZOjfIgRjeptyuic7aN+FJncjDrkL934bCXBflohwJoMWSAqJ182V3eZNAxuWprPdUz8pVCTRrnIEWnReDi8FZ5y9f38wNMp1OFplBprIEJAx/QOtsW88bmSgAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/8a370be51fabe2db40138ae34bf48586/e4706/Home_Assistant_18.avif 230w", "/en/static/8a370be51fabe2db40138ae34bf48586/d1af7/Home_Assistant_18.avif 460w", "/en/static/8a370be51fabe2db40138ae34bf48586/7f308/Home_Assistant_18.avif 920w", "/en/static/8a370be51fabe2db40138ae34bf48586/93ab0/Home_Assistant_18.avif 1284w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/8a370be51fabe2db40138ae34bf48586/a0b58/Home_Assistant_18.webp 230w", "/en/static/8a370be51fabe2db40138ae34bf48586/bc10c/Home_Assistant_18.webp 460w", "/en/static/8a370be51fabe2db40138ae34bf48586/966d8/Home_Assistant_18.webp 920w", "/en/static/8a370be51fabe2db40138ae34bf48586/26255/Home_Assistant_18.webp 1284w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/8a370be51fabe2db40138ae34bf48586/81c8e/Home_Assistant_18.png 230w", "/en/static/8a370be51fabe2db40138ae34bf48586/08a84/Home_Assistant_18.png 460w", "/en/static/8a370be51fabe2db40138ae34bf48586/c0255/Home_Assistant_18.png 920w", "/en/static/8a370be51fabe2db40138ae34bf48586/7a18f/Home_Assistant_18.png 1284w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/8a370be51fabe2db40138ae34bf48586/c0255/Home_Assistant_18.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`The device should show up with one sensor that shows the online status of our camera:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/52f0f17509486b9074e55f291a2d9df1/9cea8/Home_Assistant_19.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "42.608695652173914%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAIAAAC9o5sfAAAACXBIWXMAAA7rAAAO6wFxzYGVAAABYUlEQVQoz21R2WrkMBD0b804sa1rpG5bR0uWLceei+QhsP//vuuZLCQQKBqqoajq6oqmy1hufSgK00BLyFvIZ7CTMCQh/gphiCNpmysXVz1kCfGF4aHRx9bUHTxxbM13um8ac2g1F17XqTn2laVFYZIQO+X0kBWmRtpOuUba3ec/bR+zD0UYYspLQS2zlUu78x4S07R90HyDUFQ/Mh1SuY3lvufCpO10GvK0voMvEtPJZmZC5cft1I8CiItg7YqhGDtJTFwH3o8szNxlAVFA1A+xG7ee3jAsAqiycf2KLV3XJ2aI6SAhch1qhrUYXsTwyvuaoYQY5yvSgr6AL9xQha48xa1yDKMA6pRvtH/Vvm7NFx5V7eJy9+PZxnWIq4BYSYgKkzCkMF3e/6y3T8oXN1+5y8fmR/PCkM9nDAv4Yty8OytMTzHXIc5XN27oyxAWBfT9T4dGq0ejPu/OGMq/m/8CUNOerFOB3KIAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/52f0f17509486b9074e55f291a2d9df1/e4706/Home_Assistant_19.avif 230w", "/en/static/52f0f17509486b9074e55f291a2d9df1/d1af7/Home_Assistant_19.avif 460w", "/en/static/52f0f17509486b9074e55f291a2d9df1/7f308/Home_Assistant_19.avif 920w", "/en/static/52f0f17509486b9074e55f291a2d9df1/39beb/Home_Assistant_19.avif 1278w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/52f0f17509486b9074e55f291a2d9df1/a0b58/Home_Assistant_19.webp 230w", "/en/static/52f0f17509486b9074e55f291a2d9df1/bc10c/Home_Assistant_19.webp 460w", "/en/static/52f0f17509486b9074e55f291a2d9df1/966d8/Home_Assistant_19.webp 920w", "/en/static/52f0f17509486b9074e55f291a2d9df1/893d6/Home_Assistant_19.webp 1278w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/52f0f17509486b9074e55f291a2d9df1/81c8e/Home_Assistant_19.png 230w", "/en/static/52f0f17509486b9074e55f291a2d9df1/08a84/Home_Assistant_19.png 460w", "/en/static/52f0f17509486b9074e55f291a2d9df1/c0255/Home_Assistant_19.png 920w", "/en/static/52f0f17509486b9074e55f291a2d9df1/9cea8/Home_Assistant_19.png 1278w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/52f0f17509486b9074e55f291a2d9df1/c0255/Home_Assistant_19.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`The alarm server is also working and updating the `}<strong parentName="p">{`Trigger Topic`}</strong>{` `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`status/alarm/triggered`}</code>{` with the payload values 1 - 10 (or 99 for a manual trigger), e.g. `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`{"val":"1"}`}</code>{`:`}</p>
    <ul>
      <li parentName="ul">{`Alarm Area 1 triggered: -> `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`{"val":"1"}`}</code></li>
      <li parentName="ul">{`Alarm Area 2 triggered: -> `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`{"val":"2"}`}</code></li>
      <li parentName="ul">{`Alarm Area 3 triggered: -> `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`{"val":"3"}`}</code></li>
      <li parentName="ul">{`Alarm Area 4 triggered: -> `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`{"val":"4"}`}</code></li>
      <li parentName="ul">{`Alarm-In / PIR triggered: -> `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`{"val":"5"}`}</code></li>
      <li parentName="ul">{`Audio Alarm triggered: -> `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`{"val":"6"}`}</code></li>
      <li parentName="ul">{`PIR triggered & Alarm Area 1 triggered: -> `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`{"val":"7"}`}</code></li>
      <li parentName="ul">{`PIR triggered & Alarm Area 2 triggered: -> `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`{"val":"8"}`}</code></li>
      <li parentName="ul">{`PIR triggered & Alarm Area 3 triggered: -> `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`{"val":"9"}`}</code></li>
      <li parentName="ul">{`PIR triggered & Alarm Area 4 triggered: -> `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`{"val":"10"}`}</code></li>
      <li parentName="ul">{`Manual trigger (cmd=pushhostalarm): -> `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`{"val":"99"}`}</code></li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/4f73dd17aca5833a7cd987a147b1c6e7/f793b/Home_Assistant_26.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "39.565217391304344%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAIAAAB2/0i6AAAACXBIWXMAAA7rAAAO6wFxzYGVAAAA8UlEQVQY042Q6W6DMBCEeSYgXMYcXpv4IGBjrkSN2vd/impLeqk/GunTaNa7o5EcxCltuWFdT6oupyIlcJCVnDYyp5xUXUIhoZzUXVZyXFGeUR7GJEiKRg6bW1+n/U2NG9demPkAtOcfCI3jseLay2FT454SFiRFq+3VuJswM5MO1PQvTE3MzCfCgrRoz5cVtAc9P5PEsPbsskR5HeQlYKH2YDbQCyj/TJ7rOcobbH489Rsb79DvIB1TDvUTbPsxMjzeMRwlFL+nX8RwFfYu7At6ZP1tvnQ9juOiCcITqXnPpGXStefxYVBt++3/qg3T6h0S24bgEkgPCgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/4f73dd17aca5833a7cd987a147b1c6e7/e4706/Home_Assistant_26.avif 230w", "/en/static/4f73dd17aca5833a7cd987a147b1c6e7/d1af7/Home_Assistant_26.avif 460w", "/en/static/4f73dd17aca5833a7cd987a147b1c6e7/7f308/Home_Assistant_26.avif 920w", "/en/static/4f73dd17aca5833a7cd987a147b1c6e7/e1c99/Home_Assistant_26.avif 1380w", "/en/static/4f73dd17aca5833a7cd987a147b1c6e7/7ca8a/Home_Assistant_26.avif 1404w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/4f73dd17aca5833a7cd987a147b1c6e7/a0b58/Home_Assistant_26.webp 230w", "/en/static/4f73dd17aca5833a7cd987a147b1c6e7/bc10c/Home_Assistant_26.webp 460w", "/en/static/4f73dd17aca5833a7cd987a147b1c6e7/966d8/Home_Assistant_26.webp 920w", "/en/static/4f73dd17aca5833a7cd987a147b1c6e7/445df/Home_Assistant_26.webp 1380w", "/en/static/4f73dd17aca5833a7cd987a147b1c6e7/f028a/Home_Assistant_26.webp 1404w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/4f73dd17aca5833a7cd987a147b1c6e7/81c8e/Home_Assistant_26.png 230w", "/en/static/4f73dd17aca5833a7cd987a147b1c6e7/08a84/Home_Assistant_26.png 460w", "/en/static/4f73dd17aca5833a7cd987a147b1c6e7/c0255/Home_Assistant_26.png 920w", "/en/static/4f73dd17aca5833a7cd987a147b1c6e7/b1001/Home_Assistant_26.png 1380w", "/en/static/4f73dd17aca5833a7cd987a147b1c6e7/f793b/Home_Assistant_26.png 1404w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/4f73dd17aca5833a7cd987a147b1c6e7/c0255/Home_Assistant_26.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`You add the following configuration to the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`entities.yaml`}</code>{` file - feel free to replace the used MQTT topics with any topic from our `}<a parentName="p" {...{
        "href": "/en/Advanced_User/INSTAR_MQTT_Broker/MQTTv5_API/"
      }}>{`MQTTv5 API`}</a>{`. Once added they will show up as entities:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/88b568f04ce3648c38c582a40f6a6f43/d7e70/Home_Assistant_20.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "33.04347826086957%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAIAAACHqfpvAAAACXBIWXMAAA7rAAAO6wFxzYGVAAAA9ElEQVQY033PUU+DMBSGYX6WEQqFttBDW9rTA4MxNlATTXbr/0+MDr1Qs+S5fZPvS+K49scnGyahEcKo/VBqLzRWGssmVE0omyA0/iuxOKuWhEYmLKhBMhRpKErHpashKo0KkEtXCPtLXpnExZNqSUIsarfGK2Vn83CQCqtu7l/fzXLVxzceNxYu+TeGaxE3ZsbExbmxw21GE0blh9KgBMzNyA4vjLbMn7+a9UdGW07PzEyJp6U2/S3uaOnorNq+Nn1Rdww8V5/7/7Bc7rP3zwKio5PFWUAEP7HKpHnzyOGOBLpxjzU6OjlaXJxlS1llUg73fQAdoHmvIRAiGQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/88b568f04ce3648c38c582a40f6a6f43/e4706/Home_Assistant_20.avif 230w", "/en/static/88b568f04ce3648c38c582a40f6a6f43/d1af7/Home_Assistant_20.avif 460w", "/en/static/88b568f04ce3648c38c582a40f6a6f43/7f308/Home_Assistant_20.avif 920w", "/en/static/88b568f04ce3648c38c582a40f6a6f43/fb2c0/Home_Assistant_20.avif 1286w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/88b568f04ce3648c38c582a40f6a6f43/a0b58/Home_Assistant_20.webp 230w", "/en/static/88b568f04ce3648c38c582a40f6a6f43/bc10c/Home_Assistant_20.webp 460w", "/en/static/88b568f04ce3648c38c582a40f6a6f43/966d8/Home_Assistant_20.webp 920w", "/en/static/88b568f04ce3648c38c582a40f6a6f43/3cc91/Home_Assistant_20.webp 1286w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/88b568f04ce3648c38c582a40f6a6f43/81c8e/Home_Assistant_20.png 230w", "/en/static/88b568f04ce3648c38c582a40f6a6f43/08a84/Home_Assistant_20.png 460w", "/en/static/88b568f04ce3648c38c582a40f6a6f43/c0255/Home_Assistant_20.png 920w", "/en/static/88b568f04ce3648c38c582a40f6a6f43/d7e70/Home_Assistant_20.png 1286w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/88b568f04ce3648c38c582a40f6a6f43/c0255/Home_Assistant_20.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/e149376b41f9e3d14ff7354d80210b36/636d3/Home_Assistant_21.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "73.04347826086956%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAIAAABr+ngCAAAACXBIWXMAAA7rAAAO6wFxzYGVAAABrElEQVQoz3WSa5LjIAyEc7Od2AYj3hJgHnEmc/9TbGG8ruxWtoofLtAndbd8U67Q9qL8ApuF2VadmAwfj8E2asBsXz5PbrtpbDbsXEUmA9gNbAabF6AZaAFadVqOj+swGfqlDIsMHVaujNtJ+EUGhU3YzHViKmpsXEV+VM9Ak0Cuk6Y2H92vyaFPEwiuCJvVoXCRBK5obODKJHASeF97d6biffWTwJuhh8Y6XE2r5zqBy9KX8Sxdkb63e4e5TieM6dtgG7JnIIVN+qrxFKapaWrK13fZwmyTwC5b+QI2MxlGHjY+FVYXn6Paxt3GHVwe1Sds/8BXhn3y8QauKKyLpCHEhAfX6YLZkd8Jv2/ygKP0RfaETlhTW802XPwXXuDyXBR2oK+N2rgZQrpsFdfLM4Pulp177o1NeNi4S1e4STbsPn2b8PgrMHtGcBMuu/SU2OZD9hgOrhxbIYXVxv2K91/Zv/Iu2use6pfPM5D0FVxhKk5nowo2D8MfYOmKCU2YbfzPq9mUr8PVIoOmh6bGVLxgrt88W/yx4cFVHPD5k1DjOs1AhpoJu8L6Ef4N5McPOOMeZW0AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/e149376b41f9e3d14ff7354d80210b36/e4706/Home_Assistant_21.avif 230w", "/en/static/e149376b41f9e3d14ff7354d80210b36/d1af7/Home_Assistant_21.avif 460w", "/en/static/e149376b41f9e3d14ff7354d80210b36/7f308/Home_Assistant_21.avif 920w", "/en/static/e149376b41f9e3d14ff7354d80210b36/ea3f7/Home_Assistant_21.avif 1222w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/e149376b41f9e3d14ff7354d80210b36/a0b58/Home_Assistant_21.webp 230w", "/en/static/e149376b41f9e3d14ff7354d80210b36/bc10c/Home_Assistant_21.webp 460w", "/en/static/e149376b41f9e3d14ff7354d80210b36/966d8/Home_Assistant_21.webp 920w", "/en/static/e149376b41f9e3d14ff7354d80210b36/41bb6/Home_Assistant_21.webp 1222w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/e149376b41f9e3d14ff7354d80210b36/81c8e/Home_Assistant_21.png 230w", "/en/static/e149376b41f9e3d14ff7354d80210b36/08a84/Home_Assistant_21.png 460w", "/en/static/e149376b41f9e3d14ff7354d80210b36/c0255/Home_Assistant_21.png 920w", "/en/static/e149376b41f9e3d14ff7354d80210b36/636d3/Home_Assistant_21.png 1222w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/e149376b41f9e3d14ff7354d80210b36/c0255/Home_Assistant_21.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h4 {...{
      "id": "mqtt-switches",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#mqtt-switches",
        "aria-label": "mqtt switches permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`MQTT Switches`}</h4>
    <p>{`Switches can be used for `}<strong parentName="p">{`binary states`}</strong>{` - everything that can either be `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`on`}</code>{` or `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`off`}</code>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "yaml"
    }}><pre parentName="div" {...{
        "className": "language-yaml"
      }}><code parentName="pre" {...{
          "className": "language-yaml"
        }}><span parentName="code" {...{
            "className": "token key atrule"
          }}>{`switch`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_red_alarm_area
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Red Alarm Area
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/alarm/areas/red/enable
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/alarm/areas/red/enable
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_on`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"1"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_off`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"0"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`retain`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_blue_alarm_are
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Blue Alarm Area
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/alarm/areas/blue/enable
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/alarm/areas/blue/enable
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_on`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"1"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_off`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"0"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`retain`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_green_alarm_are
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Green Alarm Area
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/alarm/areas/green/enable
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/alarm/areas/green/enable
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_on`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"1"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_off`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"0"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`retain`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_yellow_alarm_area
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Yellow Alarm Area
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/alarm/areas/yellow/enable
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/alarm/areas/yellow/enable
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_on`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"1"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_off`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"0"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`retain`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_privacy_mask_1
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Privacy Mask 1
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/multimedia/privacy/region1/enable
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/multimedia/privacy/region1/enable
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_on`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"1"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_off`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"0"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`retain`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_privacy_mask_2
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Privacy Mask 2
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/multimedia/privacy/region2/enable
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/multimedia/privacy/region2/enable
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_on`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"1"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_off`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"0"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`retain`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_privacy_mask_3
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Privacy Mask 3
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/multimedia/privacy/region3/enable
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/multimedia/privacy/region3/enable
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_on`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"1"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_off`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"0"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`retain`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_privacy_mask_4
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Privacy Mask 4
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/multimedia/privacy/region4/enable
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/multimedia/privacy/region4/enable
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_on`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"1"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_off`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"0"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`retain`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_auto_gamma
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Auto Gamma
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/multimedia/image/gamma/auto
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/multimedia/image/gamma/auto
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_on`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"1"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_off`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"0"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`retain`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_auto_denoise
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Auto Denoise
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/multimedia/image/denoise/auto
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/multimedia/image/denoise/auto
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_on`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"1"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_off`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"0"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`retain`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_flip
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Flip
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/multimedia/image/transform/flip
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/multimedia/image/transform/flip
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_on`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"1"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_off`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"0"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`retain`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_mirror
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Mirror
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/multimedia/image/transform/mirror
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/multimedia/image/transform/mirror
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_on`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"1"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_off`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"0"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`retain`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span></code></pre></div>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/70da607dbe543b194a7415ea089d972f/28828/Home_Assistant_22.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "38.260869565217384%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAIAAAB2/0i6AAAACXBIWXMAAA7rAAAO6wFxzYGVAAAByklEQVQY00XOy04TUQDG8XkDNiYl0QAt1gJlbmfmdO7lzOWcmXNmBui0FEECgcRLRAlrgapYdZDamrgAIgsXTUyMiYkblzyPPoUpCTH5tr98fw7qdVk1JcUANdslKaYNhFPHYyhcAqrB26mS7vHhI4GMJia7QrwrsKfK8r6IH3AS0AWgi6qpWT5JVsK03VjdIkkrStqS4aJ5/lV5ulOePixOHs/NdPb3eoOP3e5xv9/b2NzkZNXgZW2Ebd+LGj7NFpsbAWsGNBMMhCvVz7dLg/GpfKzwq05+nH8dfvuZ54PLy+HjJ885STEEoEsj7Hk0w3Fr5+EzkrQClsk1pGjV++v3miuliBVev2n8+fv76uq08zK5uNje3qGceJOtO75Ps2ixfdrrx8trPsug6pbw7K3+nfFPU5PnFWkIz75bX84q3beFk3xsda3EiUDjr5+hieo4QThdaq4v4NQJYhk4Mz5fPCiWj+4K7wX1A3hxIufv5g8Oy0ediWa7ykk1a4ShJUELaI4ErVkRiqopKMacCBXd9FhkE+zSqB5iHEduSLwoxIxqDuJk3eGBDmq2qJpAc66Z/h9rZhDFThB7hKEgdAl1ArqAKSIM2ugfb5GKluSrY1wAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/70da607dbe543b194a7415ea089d972f/e4706/Home_Assistant_22.avif 230w", "/en/static/70da607dbe543b194a7415ea089d972f/d1af7/Home_Assistant_22.avif 460w", "/en/static/70da607dbe543b194a7415ea089d972f/7f308/Home_Assistant_22.avif 920w", "/en/static/70da607dbe543b194a7415ea089d972f/e1c99/Home_Assistant_22.avif 1380w", "/en/static/70da607dbe543b194a7415ea089d972f/76ea5/Home_Assistant_22.avif 1840w", "/en/static/70da607dbe543b194a7415ea089d972f/fa3bf/Home_Assistant_22.avif 2187w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/70da607dbe543b194a7415ea089d972f/a0b58/Home_Assistant_22.webp 230w", "/en/static/70da607dbe543b194a7415ea089d972f/bc10c/Home_Assistant_22.webp 460w", "/en/static/70da607dbe543b194a7415ea089d972f/966d8/Home_Assistant_22.webp 920w", "/en/static/70da607dbe543b194a7415ea089d972f/445df/Home_Assistant_22.webp 1380w", "/en/static/70da607dbe543b194a7415ea089d972f/78de1/Home_Assistant_22.webp 1840w", "/en/static/70da607dbe543b194a7415ea089d972f/2b3c8/Home_Assistant_22.webp 2187w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/70da607dbe543b194a7415ea089d972f/81c8e/Home_Assistant_22.png 230w", "/en/static/70da607dbe543b194a7415ea089d972f/08a84/Home_Assistant_22.png 460w", "/en/static/70da607dbe543b194a7415ea089d972f/c0255/Home_Assistant_22.png 920w", "/en/static/70da607dbe543b194a7415ea089d972f/b1001/Home_Assistant_22.png 1380w", "/en/static/70da607dbe543b194a7415ea089d972f/161ec/Home_Assistant_22.png 1840w", "/en/static/70da607dbe543b194a7415ea089d972f/28828/Home_Assistant_22.png 2187w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/70da607dbe543b194a7415ea089d972f/c0255/Home_Assistant_22.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/2add6936196b40102c5d3590961a4a10/a7115/Home_Assistant_23.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "38.260869565217384%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAIAAAB2/0i6AAAACXBIWXMAAA7rAAAO6wFxzYGVAAABwElEQVQY003NTWvUQADG8XwEBaGVFls3u7rmfSbvmSSbydtMkkl3s91dEWpRCxV8vwlttSrIou7aigiCBz3szYM9efCk30xKQbw8t9/z5ywnBIYHDBeaKErrrGxwXvtxiUlfN1wZVXr9SCa7Sr6rkLsSfSCQ+wK5p7AnSrLNabqrQEc1PAvFORuTekL6W2k5ovUEeDgU5cMO/7zNH7TWXnS7evuhrL0XxVeSNNPgLQ4Yngxs1fBsP8akycrB95kwaGpMRqobxV3p4wp/tLz+5vzyD5Q1/ldgnqyuHHXaCw0+/q/sY0yHhA1+feKHQ4bpGNoRtMTrN66Mxq2iXDp82f/95+d8Pt/YYDs7t0tWcSp0zrDtx0m5mVWbd24SypqUjU0T84lwYb568Xh97XNXXZhfTtDi29V3s6UPx+e2tnlOhfYZNr2ol9a9lOWUhGkVpAzA4BpWWnuXO8/aylQx3oKnU236Wtrb7+wfXBpNRA5YSIaOZiLNRNAONBOJ4PRL0V1BNXTbjUvq5xkuaEDyrCowyRNKspI6IeagG8jQAZavGgierifDf9jULTellZ9WcV6ESRHlRZAWvayI8tIO8F9yO4HEUAxYTQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/2add6936196b40102c5d3590961a4a10/e4706/Home_Assistant_23.avif 230w", "/en/static/2add6936196b40102c5d3590961a4a10/d1af7/Home_Assistant_23.avif 460w", "/en/static/2add6936196b40102c5d3590961a4a10/7f308/Home_Assistant_23.avif 920w", "/en/static/2add6936196b40102c5d3590961a4a10/e1c99/Home_Assistant_23.avif 1380w", "/en/static/2add6936196b40102c5d3590961a4a10/76ea5/Home_Assistant_23.avif 1840w", "/en/static/2add6936196b40102c5d3590961a4a10/13f89/Home_Assistant_23.avif 2186w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/2add6936196b40102c5d3590961a4a10/a0b58/Home_Assistant_23.webp 230w", "/en/static/2add6936196b40102c5d3590961a4a10/bc10c/Home_Assistant_23.webp 460w", "/en/static/2add6936196b40102c5d3590961a4a10/966d8/Home_Assistant_23.webp 920w", "/en/static/2add6936196b40102c5d3590961a4a10/445df/Home_Assistant_23.webp 1380w", "/en/static/2add6936196b40102c5d3590961a4a10/78de1/Home_Assistant_23.webp 1840w", "/en/static/2add6936196b40102c5d3590961a4a10/717b2/Home_Assistant_23.webp 2186w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/2add6936196b40102c5d3590961a4a10/81c8e/Home_Assistant_23.png 230w", "/en/static/2add6936196b40102c5d3590961a4a10/08a84/Home_Assistant_23.png 460w", "/en/static/2add6936196b40102c5d3590961a4a10/c0255/Home_Assistant_23.png 920w", "/en/static/2add6936196b40102c5d3590961a4a10/b1001/Home_Assistant_23.png 1380w", "/en/static/2add6936196b40102c5d3590961a4a10/161ec/Home_Assistant_23.png 1840w", "/en/static/2add6936196b40102c5d3590961a4a10/a7115/Home_Assistant_23.png 2186w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/2add6936196b40102c5d3590961a4a10/c0255/Home_Assistant_23.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h4 {...{
      "id": "mqtt-buttons",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#mqtt-buttons",
        "aria-label": "mqtt buttons permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`MQTT Buttons`}</h4>
    <p>{`Buttons can be used for topics that are stateless triggers - e.g. to trigger an alert or a camera reboot:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "yaml"
    }}><pre parentName="div" {...{
        "className": "language-yaml"
      }}><code parentName="pre" {...{
          "className": "language-yaml"
        }}><span parentName="code" {...{
            "className": "token key atrule"
          }}>{`button`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_alarm_trigger
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Alarm Trigger
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/alarm/pushalarm
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_press`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"1"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`icon`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` mdi`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`alarm`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`light
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`2`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`retain`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_reboot
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Reboot
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` system/reboot/now
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`payload_press`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"1"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`icon`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` mdi`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`cog`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`refresh`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`outline
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`2`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`retain`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span></code></pre></div>
    <p>{`Using the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`alarm/pushalarm`}</code>{` trigger will cause an alarm that can be recognized by the value `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`99`}</code>{` received by the MQTT alarm server on the status topic `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`alarm/triggered`}</code>{`:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/171b1dcac649fd0daf728f9d999cc15e/d10dd/Home_Assistant_24.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "28.260869565217394%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAIAAABM9SnKAAAACXBIWXMAAA7rAAAO6wFxzYGVAAABIUlEQVQY0z3O206DMADGcV7GxQuBUqBH6CinlgEFOYwtRrMHcGYxZvPeFzc63Zf/7S/5LMwSP+QwZMCnjocwT9PS5LrPlIkSzWUl8gpHNS9PLH/D6Ssvjiw/rqv3WJ2sX4Mdn3oosiFOirZfDvXjU1HPWTXmm6kwM4pNPX7JzWdcfEh9kfoi1FmoswVDfsUBESBgWdUPy4tup2bY1f1SmVkNew/RSokiiziFwLl3Hu4ce+XYKwsG7Ip9HDs+laXp5ueiHrXZ6nZWzVQOexAypbq66dI0QyF2gQc8CDz4d9sNGOKJh/g6b8bdQZtFtVttFm2W0iyuT8pSd30vhCCEgP9ZLiQuJDYkIORuwFiif0Az55vxFkQ8SdZSSkophPCGvwFPdlv0buuJTwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/171b1dcac649fd0daf728f9d999cc15e/e4706/Home_Assistant_24.avif 230w", "/en/static/171b1dcac649fd0daf728f9d999cc15e/d1af7/Home_Assistant_24.avif 460w", "/en/static/171b1dcac649fd0daf728f9d999cc15e/7f308/Home_Assistant_24.avif 920w", "/en/static/171b1dcac649fd0daf728f9d999cc15e/e1c99/Home_Assistant_24.avif 1380w", "/en/static/171b1dcac649fd0daf728f9d999cc15e/42c23/Home_Assistant_24.avif 1749w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/171b1dcac649fd0daf728f9d999cc15e/a0b58/Home_Assistant_24.webp 230w", "/en/static/171b1dcac649fd0daf728f9d999cc15e/bc10c/Home_Assistant_24.webp 460w", "/en/static/171b1dcac649fd0daf728f9d999cc15e/966d8/Home_Assistant_24.webp 920w", "/en/static/171b1dcac649fd0daf728f9d999cc15e/445df/Home_Assistant_24.webp 1380w", "/en/static/171b1dcac649fd0daf728f9d999cc15e/61421/Home_Assistant_24.webp 1749w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/171b1dcac649fd0daf728f9d999cc15e/81c8e/Home_Assistant_24.png 230w", "/en/static/171b1dcac649fd0daf728f9d999cc15e/08a84/Home_Assistant_24.png 460w", "/en/static/171b1dcac649fd0daf728f9d999cc15e/c0255/Home_Assistant_24.png 920w", "/en/static/171b1dcac649fd0daf728f9d999cc15e/b1001/Home_Assistant_24.png 1380w", "/en/static/171b1dcac649fd0daf728f9d999cc15e/d10dd/Home_Assistant_24.png 1749w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/171b1dcac649fd0daf728f9d999cc15e/c0255/Home_Assistant_24.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h4 {...{
      "id": "mqtt-sliders",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#mqtt-sliders",
        "aria-label": "mqtt sliders permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`MQTT Sliders`}</h4>
    <p>{`A `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`number`}</code>{` type entity allows us to create sliders in the Home Assistant interface. They can be used for every topic that has a number range as payload:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "yaml"
    }}><pre parentName="div" {...{
        "className": "language-yaml"
      }}><code parentName="pre" {...{
          "className": "language-yaml"
        }}><span parentName="code" {...{
            "className": "token key atrule"
          }}>{`number`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_brightness
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Brightness
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`object_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` in9408_brightness
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`icon`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` mdi`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`brightness`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`6`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/multimedia/image/brightness
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/multimedia/image/brightness
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`value_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{{ value_json.val }}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"{{ value }}"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`min`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`max`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`100`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`step`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unit_of_measurement`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'%'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_contrast
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Contrast
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`object_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` in9408_contrast
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`icon`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` mdi`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`contrast`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`box
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/multimedia/image/contrast
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/multimedia/image/contrast
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`value_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{{ value_json.val }}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"{{ value }}"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`min`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`max`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`100`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`step`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unit_of_measurement`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'%'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_saturation
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Saturation
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`object_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` in9408_saturation
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`icon`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` mdi`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`palette`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`outline
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/multimedia/image/saturation
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/multimedia/image/saturation
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`value_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{{ value_json.val }}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"{{ value }}"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`min`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`max`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`100`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`step`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unit_of_measurement`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'%'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_hue
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Hue
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`object_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` in9408_hue
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`icon`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` mdi`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`palette`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`outline
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/multimedia/image/hue
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/multimedia/image/hue
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`value_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{{ value_json.val }}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"{{ value }}"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`min`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`max`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`360`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`step`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_sharpness
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Sharpness
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`object_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` in9408_sharpness
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`icon`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` mdi`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`shark`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`fin`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`outline
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/multimedia/image/sharpness
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/multimedia/image/sharpness
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`value_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{{ value_json.val }}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"{{ value }}"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`min`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`max`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`100`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`step`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unit_of_measurement`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'%'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_vibrancy
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Vibrancy
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`object_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` in9408_vibrancy
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`icon`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` mdi`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`palette`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`outline
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/multimedia/image/vibrancy/value
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/multimedia/image/vibrancy/value
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`value_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{{ value_json.val }}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"{{ value }}"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`min`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`max`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`255`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`step`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_gamma
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Gamma
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`object_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` in9408_gamma
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`icon`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` mdi`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`gamma
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/multimedia/image/gamma/preset
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/multimedia/image/gamma/preset
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`value_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{{ value_json.val }}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"{{ value }}"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`min`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`max`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`18`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`step`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_denoise
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Denoise
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`object_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` in9408_denoise
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`icon`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` mdi`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`contrast`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`box
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/multimedia/image/denoise/preset
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/multimedia/image/denoise/preset
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`value_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{{ value_json.val }}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"{{ value }}"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`min`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`max`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`15`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`step`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_max_iso
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Max ISO
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`object_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` in9408_isomax
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`icon`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` mdi`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`brightness`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`6`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/multimedia/image/isomax
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/multimedia/image/isomax
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`value_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{{ value_json.val }}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"{{ value }}"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`min`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`max`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`32`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`step`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_auto_ir
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Auto IR LEDs
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`object_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` in9408_autoled
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`icon`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` mdi`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`lightbulb`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`night`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`outline
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/features/nightvision/autoled
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/features/nightvision/autoled
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`value_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{{ value_json.val }}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"{{ value }}"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`min`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`max`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`2`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`step`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_auto_ircut
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Auto IRcut
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`object_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` in9408_autoircut
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`icon`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` mdi`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`lightbulb`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`night`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`outline
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/features/nightvision/autoircut
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/features/nightvision/autoircut
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`value_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{{ value_json.val }}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"{{ value }}"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`min`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`max`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`2`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`step`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_red_alarm_area_sensitivity
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Red Alarm Area Sensitivity
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`object_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` in9408_red_area_sense
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`icon`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` mdi`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`cctv`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`off
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/alarm/areas/red/sensitivity
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/alarm/areas/red/sensitivity
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`value_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{{ value_json.val }}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"{{ value }}"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`min`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`max`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`100`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`step`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_blue_alarm_area_sensitivity
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Blue Alarm Area Sensitivity
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`object_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` in9408_blue_area_sense
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`icon`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'mdi:cctv-off'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/alarm/areas/blue/sensitivity
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/alarm/areas/blue/sensitivity
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`value_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{{ value_json.val }}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"{{ value }}"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`min`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`max`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`100`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`step`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_green_alarm_area_sensitivity
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Green Alarm Area Sensitivity
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`object_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` in9408_blue_area_green
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`icon`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` mdi`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`cctv`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`off
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/alarm/areas/green/sensitivity
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/alarm/areas/green/sensitivity
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`value_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{{ value_json.val }}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"{{ value }}"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`min`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`max`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`100`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`step`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{` `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`unique_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` office_yellow_alarm_area_sensitivity
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`name`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Office Yellow Alarm Area Sensitivity
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`object_id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` in9408_blue_area_yellow
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`icon`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` mdi`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`cctv`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`off
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`state_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/status/alarm/areas/yellow/sensitivity
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_topic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` cameras/201/alarm/areas/yellow/sensitivity
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`value_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{{ value_json.val }}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`command_template`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'{"val":"{{ value }}"}'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`min`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`0`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`max`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`100`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`step`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`qos`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token key atrule"
          }}>{`optimistic`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean important"
          }}>{`false`}</span></code></pre></div>
    <p>{`Adjust the slider to adjust the sensitivity used for the corresponding motion detection area:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/ddcaf3e451a9c27204e5a8dd2bd4b173/5b2ff/Home_Assistant_25.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "40.43478260869565%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAA7rAAAO6wFxzYGVAAAB8ElEQVQoz0WRS08TARRG5ycYEyVBpYgQoUOn8+o82plpZzqdV6WlHWITFA2JCfggUowufOBCNkYgxpWJGuJj6cq9W//WMR0iLm7uzV2cnPtdQTdddMNB1myqqoWs1wmiHp10QJQN8aIV3CClavoYNx6gJdso8RZqvIWU7SKmY8rxY9TBc5acHEEzHCTFRJrAanV0u0VvbYPuYJ2kP6LdHxH0bqKoBntzJQ6uzvBy5jJvF0rYpU0Wl48QF98glt+xVB4iGHazMKuoForRoFZv0U6H+PFqUUE8oBmvFsBXs9d4f2WO1+en+Gnb7OY/sL1fzJYOKZdPqEh3EdRa48xwAtQsj3aa/68sJ0iGSJpB69Y8yfY8jfVp7uw7/P5zwpdP+9zecBmPB4QdC6GAKeapYe3UMOmNCsswywm7OUGWU6kZXHgxzcUPl5j7eJ2FrzIH3yW+fZ7n8GiK4+NzDPISgqxapycrZvGQSYb9tY0z6D/Das2kvLmMuCOijlW0pwb3nlk82dO5/7DCo50KYVxBqFouVaPBsmIWhorhEsR9/KiHE2S47S4NP0VSTYIwwWnGtMMunp/QCrs4QYLbzvCjFWSjgTDJrKrbZ8CqXi/6JILJTtJsRNlAlHW8sIMTJnidGC+MaXYimuFkjvDjFNW0+QtlNR78S64ISQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/ddcaf3e451a9c27204e5a8dd2bd4b173/e4706/Home_Assistant_25.avif 230w", "/en/static/ddcaf3e451a9c27204e5a8dd2bd4b173/d1af7/Home_Assistant_25.avif 460w", "/en/static/ddcaf3e451a9c27204e5a8dd2bd4b173/7f308/Home_Assistant_25.avif 920w", "/en/static/ddcaf3e451a9c27204e5a8dd2bd4b173/e1c99/Home_Assistant_25.avif 1380w", "/en/static/ddcaf3e451a9c27204e5a8dd2bd4b173/76ea5/Home_Assistant_25.avif 1840w", "/en/static/ddcaf3e451a9c27204e5a8dd2bd4b173/5c924/Home_Assistant_25.avif 2190w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/ddcaf3e451a9c27204e5a8dd2bd4b173/a0b58/Home_Assistant_25.webp 230w", "/en/static/ddcaf3e451a9c27204e5a8dd2bd4b173/bc10c/Home_Assistant_25.webp 460w", "/en/static/ddcaf3e451a9c27204e5a8dd2bd4b173/966d8/Home_Assistant_25.webp 920w", "/en/static/ddcaf3e451a9c27204e5a8dd2bd4b173/445df/Home_Assistant_25.webp 1380w", "/en/static/ddcaf3e451a9c27204e5a8dd2bd4b173/78de1/Home_Assistant_25.webp 1840w", "/en/static/ddcaf3e451a9c27204e5a8dd2bd4b173/94170/Home_Assistant_25.webp 2190w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/ddcaf3e451a9c27204e5a8dd2bd4b173/81c8e/Home_Assistant_25.png 230w", "/en/static/ddcaf3e451a9c27204e5a8dd2bd4b173/08a84/Home_Assistant_25.png 460w", "/en/static/ddcaf3e451a9c27204e5a8dd2bd4b173/c0255/Home_Assistant_25.png 920w", "/en/static/ddcaf3e451a9c27204e5a8dd2bd4b173/b1001/Home_Assistant_25.png 1380w", "/en/static/ddcaf3e451a9c27204e5a8dd2bd4b173/161ec/Home_Assistant_25.png 1840w", "/en/static/ddcaf3e451a9c27204e5a8dd2bd4b173/5b2ff/Home_Assistant_25.png 2190w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/ddcaf3e451a9c27204e5a8dd2bd4b173/c0255/Home_Assistant_25.png",
              "alt": "Home Assistant with Docker",
              "title": "Home Assistant with Docker",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <ForumBox mdxType="ForumBox" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      